import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _, { isArray } from 'lodash'
import moment from 'moment'
import RemuneracaoMedicaApi from '@/Apis/RemuneracaoMedica/RemuneracaoMedica'
import { Apis } from '@finx/web-repository'
import { isEqual, filtrarItensPorAcao } from '@/utils/common'
import { RemuneracaoMedica } from '@/types/core'
// eslint-disable-next-line
import {
  CargaRemuneracaoLog,
  PrestadorRecebimento,
  SituacaoRemuneracaoEnum,
  SituacoesFiltro,
  TemplateNotificarConfig,
  PrestadoresRecebimentoSearch,
  TabelasDeReferencia,
  BackofficeProducao,
  Procedimentos,
  ItemsCargaRemuneracao,
  ItemSenioridade,
  ItemAvulso,
  ItemTabelaPrecoProcedimento,
  ItemPontuacaoProfissional,
  ItemTaxaAluguel,
  PrestadorTaxaAluguel,
  TaxaAluguelTipoEnum,
  MensagensDaApiEnum,
  // eslint-disable-next-line
} from '@/types/_'
import { IRemuneracaoBackofficeMessage } from '@/types/interfaces/backoffice-remuneracao/backoffice-remuneracao-message'
import { FiltrosRecebimentoMonitor } from '@/types/interfaces/RecebimentoMonitor'
import { LotesNotificacaoParams, LoteDetalhesParams } from '@/types/interfaces/LoteNotificacao'
import { signalRRemuneracaoBackofficeService } from '../../../../services/signalR-remuneracao-backoffice.service'

const TAXA_PADRAO = 'TAXA PADRÃO'

// Sequência das buscas da listagem de lotes de NF. A tela dispara mais de um GET
// concorrente (mount + paginação + polling); sem isso, uma resposta antiga pode chegar
// depois e sobrescrever a mais nova, fazendo o botão de download voltar a "Em andamento".
let seqDownloadNotasFiscais = 0

// Mesma corrida na listagem do Recebimento Monitor: trocar filtro ou periodo dispara buscas
// concorrentes, e a resposta mais antiga pode chegar por ultimo e sobrescrever a mais nova.
let seqMonitoramentoCargas = 0

@Module({ namespaced: true, name: 'FinanceiroStore' })
export default class FinanceiroStore extends VuexModule {
  public modal: any = {
    atualizarNotaFiscal: false,
    multiplasNotasFiscais: false,
    editarNotaFiscal: false,
    desfazerLiberacao: false,
    criarEditarItemSenioridade: false,
    criarEditarItemTabelaPrecoProcedimento: false,
    novoItemAvulsoRepasse: false,
    validacaoEGeracaoRepasse: false,
    procedimentosDescartados: false,
    gerarRepasse: false,
    emitirRelatorioEmLote: false,
    itensDoRepasse: false,
    modalAlterarAluguelPrestador: false,
    modalAlterarPontuacaoProfissional: false,
    modalAlterarPrestador: false,
    criarEditarItemPontuacaoProfissional: false,
    criarEditarItemTaxaAluguel: false,
    criarEditarEspecialidade: false,
    criarEditarSubEspecialidade: false,
    criarEditarEspecialidadeProcedimento: false,
    importarProcedimentos: false,
    excluirItemRepasse: false,
    filtroDownloadNotaFiscal: false,
    descontosPrestador: false,
    integrarRepasses: false,
    integrarRepasseUnico: false,
    liberarRepasses: false,
    emitirRelatorio: false,
    descartarRepasses: false,
    desfazerIntegracao: false,
    errosValidacao: false,
    liberarRepasseUnico: false,
    modelosCargaRemuneracao: false,
    recalcularRepasse: false,
    itemsRecebimentoMonitor: false,
    itemsRecebimentoErros: false,
    repassesCarregados: false,
    integrarRepasseMultiplo: false,
    liberarRepasseMultiplo: false,
    criarTabelaPreco: false,
    recalcularImpostosEAlugueis: false,
    errosCarga: false,
    logsPrestadorRecebimento: false,
    alterarDatas: false,
    criarParametrosAplicacao: false,
    incluirNovasProducoes: false,
  }

  private agrupamentoRepasseDefault: any = {
    message: '',
    agrupamento: {
      id: '',
      numeroChamado: '',
    },
    somatorioTotalNotas: 0,
    arquivoNotasFiscais: '',
  }

  private exportarRegistrosDefault: any = {
    message: '',
    registros: {
      grupoRepasseId: '',
      anoMesReferencia: '',
      fontePagadoraId: '',
    },
  }

  private finalizarProcessosDefault: any = {
    message: '',
    processos: {
      grupoRepasseId: '',
      anoMesReferencia: '',
      fontePagadoraId: '',
    },
  }

  private itensDoRepasseDefault: any = {
    dataRecebimento: '',
    empresaMedicaDocumento: '',
    empresaMedicaNome: '',
    fontePagadoraDocumento: '',
    fontePagadoraNome: '',
    itens: [{
      id: '',
      acomodacao: '',
      codigoTuss: '',
      dataRealizacao: '',
      dataRecebimento: '',
      descricaoTuss: '',
      fontePagadoraNome: '',
      funcaoDescricao: '',
      localExecucaoNome: '',
      numeroAtendimento: '',
      operadoraNome: '',
      paciente: '',
      profissionalNome: '',
      quantidade: 0,
      urgente: false,
      valorBruto: 0,
      viaAcesso: '',
    }],
    mesReferenciaPagamento: '',
    numeroRepasse: '',
    paginaAtual: 0,
    totalPaginas: 0,
    totalRegistros: 0,
    valorTotal: 0,
  }

  private prestadorRecebimentoDefault: PrestadorRecebimento = {
    id: '',
    documentoId: '',
    fontePagadoraNome: '',
    fontePagadoraDocumento: '',
    numeroRepasse: '',
    prestadorNome: '',
    numeroChamado: 0,
    prestadorDocumento: '',
    dataLiberacao: '',
    dataPrevisaoPagamento: '',
    ordemDeCompra: '',
    numeroPedido: '',
    mesReferenciaPagamento: 1,
    numeroAtendimento: '',
    descricaoDivergencia: '',
    valorNota: 0,
    valorRepasse: 0,
    motivo: [],
    divergencia: false,
    dataRecebimentoNota: '',
    numeroNota: '',
    numeroContasPagar: 0,
    layoutRelatorio: 0,
    comentario: '',
    medicoNome: [],
    nomeArquivoOriginal: '',
    codPrestador: '',
    codFontePagadora: '',
    responsavelCodHis: '',
    inscricaoMunicipal: '',
    userId: '',
    notasFiscais: [
      {
        createdByNome: '',
        createdOn: '',
        dataRecebimentoNota: '',
        descricaoDivergencia: '',
        divergencia: false,
        documentoId: '',
        motivo: [],
        nomeArquivoOriginal: '',
        notaCancelada: false,
        numeroContasPagar: '',
        numeroNota: '',
        prestadorRecebimentoId: '',
        situacao: '',
        valorNotaFiscal: 0,
        comentario: '',
      },
    ],
    fontePagadoraId: {
      display: '',
      key: '',
    },
    grupoRepasseId: {
      display: '',
      key: '',
    },
    grupoRepasse: {
      display: '',
      key: 0,
    },
    acoes: {
      atualizar: false,
      falarPrestador: false,
      podeProvisionar: false,
      visualizar: false,
      podeDeletarNotaFiscal: false,
      podeCancelarProvisionamento: false,
    },
    dataUltimaNotificacao: '',
    situacao: {
      display: '',
      key: '',
    },
    notaCancelada: false,
  }

  private templateNotificarConfigDefault: TemplateNotificarConfig = {
    assunto: '',
    emailContato: '',
    emailCorpo: '',
    emailResposta: '',
    nomeHospital: '',
    tipo: 0,
  }

  private profissionaisExecutantesDefault: any[] = []
  private motivosInclusaoItemAvulsoDefault: any[] = []
  private codigoProcedimentoDefault: any[] = []
  private transacaoFiananceiraDefault: any[] = []
  private centroDeCustoDefault: any[] = []

  private pontuacoesDefault: any[] = []

  private tabelasAMBDefault: any = {
    id: '',
    nome: '',
  }

  private itemsTabelaPrecoDefault: any[] = []

  private itemsTabelaPrecoIndiceDefault: any[] = []

  private itemsConveniosRegrasDefault: any[] = []

  private itemAvulsoDefault: ItemAvulso = {
    id: '',
    valor: 0,
    transacaoFinanceira: '',
    contaContabil: '',
    centroDeCusto: '',
    profissional: '',
    observacao: '',
    urgente: false,
  }

  private prestadoresRecebimentosDefault: PrestadorRecebimento[] = []
  private itemsCargaRemuneracaoDefault: ItemsCargaRemuneracao[] = []
  private backofficeProcedimentosDefault: Procedimentos[] = []
  private geracaoDeRepassesItemsDefault: any[] = []
  private tabelasDeReferenciaDefault: TabelasDeReferencia[] = []
  private backofficeProducaoDefault: BackofficeProducao[] = []
  public itemAvulso: ItemAvulso = { ...this.itemAvulsoDefault }
  public geracaoDeRepassesItems: any[] = [...this.geracaoDeRepassesItemsDefault]
  public geracaoDeRepassesItemsVisualizar: any[] = []
  public cargasVisualizarItems: any[] = []
  public procedimentosDescartados: any[] = []
  public procedimentosDescarteRecriacao: any[] = []
  public totalProcedimentosDescarteRecriacao: number = 0
  public acoesGeracaoRepasse: any = {}
  public acoesItensDoRepasse: any = {}
  public activeTab: number = 0
  public dadosGeraisDoRepasse: any = {}
  public relatorioId: string = ''
  public pessoaId: string = ''
  public impostoId: string = ''
  public alicota: string = ''
  public valorMinimoTributo: string = ''
  public geracaoDeRepassesItemsPrestador: any[] = []
  public notaFiscalUnica: any = {}
  public documentoId: any = ''
  public prestadorRecebimento: PrestadorRecebimento = { ...this.prestadorRecebimentoDefault }
  public backofficeProcedimentos: Procedimentos[] = { ...this.backofficeProcedimentosDefault }
  public templateNotificarConfig: TemplateNotificarConfig = { ...this.templateNotificarConfigDefault }
  public prestadoresRecebimentos: PrestadorRecebimento[] = [...this.prestadoresRecebimentosDefault]
  public colunasOcultarItems: any[] = []
  public itemsCargaRemuneracao: ItemsCargaRemuneracao[] = [...this.itemsCargaRemuneracaoDefault]
  public itemsDownloadNotasFiscais: any[] = []
  public vinculosRelatorios: any[] = []
  public itemsMonitoramentoCargas: any[] = []
  public tipoFilter: any = ''
  public statusFilter: any = ''
  public totalItemsMonitoramentoCargas: number = 0
  public impostoPrestadores: any[] = []
  public relatoriosAll: any[] = []
  public totalItemsDownloadNotasFiscais: number = 0
  public anoMesReferenciaDownloadNotasFiscais: string = ''
  public createdOnNFDe: string = ''
  public createdOnNFAte: string = ''
  public fontePagadoraIdDownloadNotasFiscais: string = ''
  public grupoRepasseDownloadNotasFiscais: string = ''
  public situacoesDoRepasseDownloadNotasFiscais: string = ''
  public geradoPorDownloadNotasFiscais: string = ''
  public usuariosGeradoresDownload: any[] = []
  public tabelasDeReferencia: TabelasDeReferencia[] = [...this.tabelasDeReferenciaDefault]
  public itensRecebimentoMonitor: any[] = []
  public repassesCarregados: any[] = []
  public totalItensRepassesCarregados: number = 0
  public itensRecebimentoErros: any[] = []
  public backofficeProducao: BackofficeProducao[] = [...this.backofficeProducaoDefault]
  public cargaLogs: CargaRemuneracaoLog[] = []
  public itemsTabelaValidacao: any[] = []
  public tabelasAMB: any = { ...this.tabelasAMBDefault }
  public itemsTabelaPreco: any[] = [...this.itemsTabelaPrecoDefault]
  public isEdit: boolean = false
  public itemsTabelaPrecoDetails: any[] = []
  public itemsTabelaPrecoIndice: any[] = [...this.itemsTabelaPrecoIndiceDefault]
  public itemsConveniosRegras: any[] = [...this.itemsConveniosRegrasDefault]
  public itemsTabelaAmb: any[] = []
  public itemsRegrasProfissional: any[] = []
  public descontosPrestador: any[] = []
  public agrupamentoRepasse: any = { ...this.agrupamentoRepasseDefault }
  public exportarRegistros: any = { ...this.exportarRegistrosDefault }
  public finalizarProcessos: any = { ...this.finalizarProcessosDefault }
  public itensDoRepasse: any = { ...this.itensDoRepasseDefault }
  public relatorioEmitido: any = {}
  public downloadTipoCarga: any = {}
  public notaFiscalItem: any = {}
  public idForDeleteNotaFiscal: string = ''
  public relatorioEmissaoId: string = ''
  public descarteId: string = ''
  public emitirRelatorioEmLote: string[] = []
  public validacaoErros: any[] = []
  public situacoes: string[] = []
  public funcoes: string[] = []
  public statusGeracaoRepasse: string | string[] | any = []
  public fontePagadoraFilter: string = ''
  // FXSR-2689 — filtros da listagem de gerações. Estados próprios de propósito: selectedPrestador e
  // selectedProfissionalExecutante pertencem à lista de repasses de dentro da geração.
  public geracaoProfissionalFilter: string = ''
  public geracaoPrestadorFilter: string = ''
  public geracaoProfissionaisOptions: any[] = []
  public geracaoPrestadoresOptions: any[] = []
  public nomeEquipeFilter: string = ''
  public tipoItens: string = ''
  public apenasDivergente: boolean = false
  public alterarFuncao: string = ''
  public dataPrazo: string = ''
  public dataPrevisao: string = ''
  public situacoesValidacao: string[] = ['Calculado']
  public errosValidacao: string[] = []
  public errosCarga: string[] = []
  public tabelaId: string[] = []
  public convenioRegras: string = ''
  public multiplicador: string = ''
  public taxaAdm: string = ''
  public valorDeReferencia: string = ''
  public aplicarFatorAcomodacao: boolean = false
  public indiceAtualRegras: boolean = false
  public tabelaReferencia: string = ''
  public tabelaIndice: string = ''
  public itemUpdateId: string = ''
  public profissionalRegrasId: string = ''
  public fontePagadoraRegrasId: string = ''
  public codigoTuss: string = ''
  public codigoAMB: string = ''
  public medicoProducaoProcedimentoId: string = ''
  public descricaoTuss: string = ''
  public modalContext: any = null
  public isNewNotaFiscal: boolean = false
  public nome: string = ''
  public equipeProfissionalId: string = ''
  public hospitalId: string = ''
  public equipesOptions: any[] = []
  public hospitaisOptions: any[] = []
  public tabelaAmbId: string = ''
  public profissionaisExecutantes: any[] = [...this.profissionaisExecutantesDefault]
  public prestadoresRepasse: any[] = []
  public statusGeracaoRepasseFiltro: any[] = []
  public funcoesProfissionalExecutante: any[] = []
  public conveniosRepasse: any[] = []
  public conveniosList: any[] = []
  public planosRepasse: any[] = []
  public viasAcesso: any[] = []
  public motivosInclusaoItemAvulso: any[] = [...this.motivosInclusaoItemAvulsoDefault]
  public codigoProcedimento: any[] = [...this.codigoProcedimentoDefault]
  public transacaoFinanceira: any[] = [...this.transacaoFiananceiraDefault]
  public centroDeCusto: any[] = [...this.centroDeCustoDefault]
  public codigoProcedimentoId: string = ''
  public observacao: string = ''
  public urgente: boolean = false
  public excelRepasse: any = null
  public numeroAtendimento: string = ''
  public hisProcedimento: string = ''
  public dataAtendimento: string = ''
  public codigoItens: string = ''
  public itemAvulsoRepasse: any = {}
  public centroDeCustoId: string = ''
  public equipeIdSelected: any = ''
  public hospitalIdSelected: any = ''
  public pontuacaoSelected: any = ''
  public transacaoFinanceiraId: string = ''
  public valorProcedimento: number = 0
  public quantidade: number = 0
  public pontuacoes: any = [...this.pontuacoesDefault]
  public convenio: string = ''
  public situacoesFiltro: SituacoesFiltro[] = []
  public funcoesFiltro: any[] = []
  public filterOn: boolean = false
  // flag propria da listagem de geracoes: o filterOn e compartilhado com o modal da geracao,
  // que o zera ao fechar e sumia com o "Limpar filtros" da tela de tras (FXSR-2715)
  public geracaoFilterOn: boolean = false
  public filterDrawer: boolean = false
  public filterValidacaoEGeracaoRepasseDrawer: boolean = false
  public geracaoDrawer: boolean = false
  public filterProcedimentosDescartadosDrawer: boolean = false
  public agrupamentoRpas: boolean = false
  public profissionais: string = ''
  public convenios: string = ''
  public solicitacaoId: string = ''
  public tiposCarga: any[] = []
  public criadoresCarga: any[] = []
  public filtroCargaPeriodoDe: string = ''
  public filtroCargaPeriodoAte: string = ''
  public filtroCargaCriadoPor: string = ''
  public filtroCargaTipo: string = ''
  public filtroCargaNomeArquivo: string = ''
  public filtroCargaStatus: string = ''
  public filtroCargaTemErro: string = ''
  public disabledConfirmar: boolean = false
  public tipoCargaSelected: string = ''
  public naoCarregarPrestadorComCalculo: boolean = false

  private paginaDefault: number = 1
  private pageItemsDefault: number = 1
  private paginaProducaoDefault: number = 1
  private somatorioTotalNotasDefault: number = 0
  private qtdPorPaginaDefault: number = 50
  // private filtroTextoDefault: string = ''
  private prestadoresListaDefault: PrestadoresRecebimentoSearch[] = []

  public pagina: number = this.paginaDefault
  public paginaValidacaoEGeracao: number = this.paginaDefault
  public paginaRepassesCarregados: number = this.paginaDefault
  public paginaProcedimentosDescarteRecriacao: number = this.paginaDefault
  public paginaGeracao: number = this.paginaDefault
  public idForLoadValidacaoEGeracaoRepasse: string = ''
  public idForCloseGeracao: string = ''
  public idForLoadProcedimentosDescartados: string = ''
  public temProcedimento: boolean = false
  public podeLiberar: string = ''
  public podeDescartar: boolean = false
  public idForLoadItensRepasse: string = ''
  public idPrestadorRecalculo: string = ''
  public idGeracaoRepasse: string = ''
  public idForLoadPrestadores: string = ''
  public prestadorRecebimentoId: string = ''
  public statusGeracaoDeRepasse: string = ''
  public idForLoadItemAvulso: string = ''
  public tipoGeracaoRepasse: string = ''
  public pageItems: number = this.pageItemsDefault
  public paginaProducao: number = this.paginaProducaoDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  // public filtroTexto: string = this.filtroTextoDefault
  public totalPrestadorRemuneracao: number = 0
  public totalGeracaoDeRepasse: number = 0
  public exibirNumeroChamado: boolean = false
  public tipoEnum: string[] = []
  public totalItensPrestador: number = 0
  public quantidadeTotal: number = 0
  public valorTotal: number = 0
  public totalItemsCargaRemuneracao: number = 0
  public mensagemLogDesfazer: string = ''
  public itemsTabelaValidacaoTotal: number = 0
  public totalGeracaoDeRepasseVisualizar: number = 0
  public totalProcedimentosDescartados: number = 0
  public totalRepasseItems: number = 0
  public itemsId: string = ''
  public totalTabelaDeReferencia: number = 0
  public logsPrestadorRecebimento: any[] = []
  public total: number = 0
  public totalBackofficeProducao: number = 0
  public totalIntegracaoGeralRepasses: number = 0
  public totalPageBackofficeProducao: number = 0
  public grupoRepasse: string = ''
  public grupoRepasseFinalizarProcessos: string = ''
  public layoutRelatorio: boolean | null = false
  public grupoRepasseItens: any[] = []
  public linkParaEnvioDaNF: string = ''
  public itemRepasse: any = {}
  public grupoRepasseItensAll: any[] = []
  public fontePagadoraId: string = ''
  public situacoesExportarRegistros: string = ''
  public estabelecimentoGerarRepasseId: string = ''
  public prestadorGerarRepasse: string = ''
  public condicaoPagamentoGerarRepasseId: string = ''
  public tipoAluguelPrestador: string = ''
  public valorAluguelPrestador: string = ''
  public motivoInclusao: string = ''
  public profissionalPontuacao: string = ''
  public profissionalPontuacaoNome: string = ''
  public prestadorRepasse: any = {}
  public funcaoProfissionalExecutante: string = ''
  public convenioRepasse: string = ''
  public planoRepasse: string = ''
  public viaAcesso: string = ''
  public prestadorIdFilter: string = ''
  public pontuacaoProfissional: string = ''
  public aluguelPrestadorId: string = ''
  public grupoRepasseId: string = ''
  public numeroChamado: string = ''
  public email: string = ''
  public nomePrestador: string = ''
  public codigoRegra: string = ''
  public buscaProducao: string = ''
  public somatorioTotalNotas: number = this.somatorioTotalNotasDefault
  public fontePagadoras: any[] = []
  public tipoItensList: any[] = []
  public profissionaisList: any[] = []
  public allProfissionaisList: any[] = []
  public gerarRepassePrestadores: any[] = []
  public statusList: any[] = []
  public selectedPrestador: string = ''
  public selectedTipo: any[] = []
  public selectedStatus: any[] = []
  public condicoesPagamento: any[] = []
  public anoMesCompetencia: string = ''
  public anoMesReferencia: string = ''
  public transacaoUnica: boolean = false
  public anoMesReferenciaDe: string = ''
  public anoMesReferenciaAte: string = ''
  public anoMesReferenciaListaRepasse: string = ''
  public anoMesReferenciaExportarRegistros: string = ''
  public relatorioSelected: string = ''
  public anoMesReferenciaFinalizarProcessos: string = ''
  public anoMesReferenciaGeracaoRepasse: string = ''
  public impostoPrestadorId: string = ''
  public anoMesReferenciaDoRepasse: string = ''
  public dataEnvioNotaFiscalGeracaoRepasse: string = ''
  public dataVencimentoGeracaoRepasse: string = ''
  public anoMesReferenciaRecalcularValores: string = ''
  public dataRecebimentoRecalcularValores: string = ''
  public prazoRecalcularValores: string = ''
  public numeroRepasse: string = ''
  public contasPagar: string = ''
  public numeroNota: string = ''
  public valorNota: string = ''
  public enablePodeEncerrarRepasses: boolean = false
  public prestadorId: string = ''
  public prestadorNome: string = ''
  public profissionalRepasse: string = ''
  public nomeProfissionalRepasse: string = ''
  public medicoRecebimentoIds: any[] = []
  public nomePaciente: string = ''
  public numeroConta: string = ''
  public seqProcedimentoHis: string = ''
  public operadoraId: string = ''
  public planoOperadoraId: string = ''
  public profissionalExecutanteId: string = ''
  public competenciaFaturamentoAnoMes: string = ''
  public competenciaRepasseAnoMes: string = ''
  public codigoRepasse: string = ''
  public exibirOpcaoRelatorioAssinaturaDiretoria: boolean = false
  public prestadoresLista: PrestadoresRecebimentoSearch[] = [...this.prestadoresListaDefault]
  public impostoPrestadorList: any[] = []
  public idForSaveAlterarPrestador: string = ''
  public idForDesfazerRepasse: string = ''
  public calculoAtivo: boolean = false
  public selectedProfissionalExecutante: string = ''
  public profissional: string = ''
  public filtroValorPontuacao: string = ''
  public filtroHospitalId: string = ''
  public filtroEquipeProfissional: string = ''
  public filtroCodigoPontuacaoOuNome: string = ''
  public equipesMedicas: any[] = []
  public acoesItemRecebimento: any = {}
  public periodos: any[] = []
  public integracaoGeralRepasses: any[] = []
  public selectedPeriodo: string = ''
  public dataExecucaoDe: string = ''
  public dataExecucaoAte: string = ''
  public codigo: string = ''
  public loadingTipoItens: boolean = false
  public loadingProfissionais: boolean = false
  public loadingFuncoesProfissionalExecutante: boolean = false
  public configsParametrosAplicacao: any[] = []
  public tipoRelatorio: string = ''
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  public backofficeProducaoHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome paciente', value: 'nomePaciente', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Local execução', value: 'localExecucao', sortable: false },
    { text: 'Data Realização', value: 'dataRealizado', sortable: false },
    { text: 'Valor total', value: 'valorTotal', sortable: false },
    { text: 'Status do pagamento', value: 'statusPagamento', sortable: false },
  ]

  public descontosPrestadorHeader: any[] = [
    { text: 'Nome', value: 'nome', align: 'center', sortable: false },
    { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
    { text: 'Percentual', value: 'percentual', align: 'center', sortable: false },
  ]

  public headersTabelaValidacao: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Profissional', value: 'profissional', sortable: false },
    { text: 'Função', value: 'funcao', sortable: false },
    { text: 'Código TUSS', value: 'codigoProc', sortable: false },
    { text: 'Convênio', value: 'convenio', sortable: false },
    { text: 'Data da cirurgia', value: 'dataCirurgia', sortable: false },
    { text: 'Qtde.', value: 'quantidade', sortable: false },
    { text: 'Faturado', value: 'faturado', sortable: false },
    { text: 'Repassado', value: 'repassado', sortable: false },
    { text: '% Repassado', value: 'porcentagemRepassado', sortable: false },
    { text: 'Situação', value: 'situacao', sortable: false },
    { text: 'Ações', value: 'acoes', sortable: false },
  ]

  public headersTabelaAMB: any[] = [
    { text: 'Código', value: 'codigo', align: 'center', sortable: false },
    { text: 'Código Tuss', value: 'codigoTuss', align: 'center', sortable: false },
    { text: 'Descrição Tuss', value: 'descricaoTuss', align: 'center', sortable: false },
    { text: 'Ações', value: 'acoes', align: 'left', sortable: false },
  ]

  public headersRegraProfissional: any[] = [
    { text: 'Código regra', value: 'codigoHisRegra', align: 'center', sortable: false },
    { text: 'Descrição regra', value: 'descricaoRegra', align: 'center', sortable: false },
    { text: 'Fonte Pagadora', value: 'nomePrestador', align: 'center', sortable: false },
    { text: 'Convênio', value: 'nomeFontePagadora', align: 'center', sortable: false },
    { text: 'Multiplicador', value: 'fatorMedico', align: 'center', sortable: false },
    { text: 'Taxa Adm.', value: 'percentualTaxaAdministrativa', align: 'center', sortable: false },
    { text: 'Tabela referência', value: 'nomeTabelaPreco', align: 'center', sortable: false },
    { text: 'Tabela Índice', value: 'nomeTabelaIndice', align: 'center', sortable: false },
    { text: 'Editar', value: 'edit', align: 'center', sortable: false },
  ]

  public headersRegrasProfissional: any[] = [
    { text: 'Nome Profissional', value: 'nomeProfissional', sortable: false },
    { text: 'Nome Prestador', value: 'nomePrestador', sortable: false },
    { text: 'Nome Fonte Pagadora', value: 'nomeFontePagadora', sortable: false },
    { text: 'Categoria Dedicação', value: 'categoriaDedicacao', sortable: false },
    { text: 'Data da Cirurgia', value: 'dataCirurgia', sortable: false },
    { text: 'Pontuação Dedicação', value: 'pontuacaoDedicacao', sortable: false },
  ]

  public headersTabelaDeSenioridade: any[] = [
    { text: 'Categoria dedicação', value: 'categoiriaDeticacao', align: 'center', sortable: false },
    { text: 'Pontuação dedicação', value: 'pontuacaoDedicacao', align: 'center', sortable: false },
    { text: 'Percentual incentivo', value: 'percentualIncentivo', align: 'center', sortable: false },
  ]

  public backofficeProcedimentosHeader: any[] = [
    { text: '', value: '', align: 'center', sortable: false },
    { text: 'Código', value: 'codigo', align: 'center', sortable: false },
    { text: 'Descricao', value: 'descricao', align: 'center', sortable: false },
    { text: 'Sequencia', value: 'sequencia', align: 'center', sortable: false },
    { text: 'Quantidade', value: 'quantidade', align: 'center', sortable: false },
    { text: 'Via', value: 'viaAcesso', align: 'center', sortable: false },
  ]

  public tabelasDeReferenciaTableHeader: any[] = [
    { text: 'Nome tabela', value: 'nomeTabela', sortable: false },
    { text: 'Cód. único', value: 'codigoUnico', sortable: false },
    { text: 'Descrição', value: 'descricao', sortable: false },
    { text: 'Valor recebimento', value: 'valorProcedimento', sortable: false },
    { text: 'Fator via única', value: 'fatorViaUnica', sortable: false },
    { text: 'Fator via separada', value: 'fatorViaSeparada', sortable: false },
    { text: 'Fator via bilateral', value: 'fatorViaBilateral', sortable: false },
    { text: 'Fator via mesma', value: 'fatorViaMesma', sortable: false },
    { text: 'Fator cirurgião', value: 'fatorCirurgiao', sortable: false },
    { text: 'Fator auxiliar 1', value: 'fatorAuxiliar1', sortable: false },
    { text: 'Fator auxiliar 2', value: 'fatorAuxiliar2', sortable: false },
    { text: 'Fator auxiliar 3', value: 'fatorAuxiliar3', sortable: false },
    { text: 'Fator auxiliar 4', value: 'fatorAuxiliar4', sortable: false },
  ]

  public tabelaCargaRemuneracaoHeader: any[] = [
    { text: 'Data da criação', value: 'createdOn', sortable: true },
    { text: 'Criado por', value: 'createdByNome', sortable: false },
    { text: 'Tipo', value: 'tipóImportacao', sortable: false },
    { text: 'Nome arquivo', value: 'nomeArquivo', sortable: false },
    { text: 'Tamanho', value: 'tamanhoArquivo', align: 'center', sortable: false },
    { text: 'Total de itens', value: 'totalItens', sortable: false },
    { text: 'Status', value: 'status', sortable: true },
    { text: 'Erro', value: 'temErro', sortable: true },
    { text: 'Concluido em', value: 'concluidoEm', sortable: false },
    { text: 'Log', value: 'log', align: 'center', sortable: false },
    { text: 'Ação', value: 'acao', align: 'center', sortable: false },
  ]

  public tabelaDownloadNotasFiscais: any[] = [
    { text: 'Data da criação', value: 'createdOn', sortable: false },
    { text: 'Nome arquivo', value: 'nomeArquivo', sortable: false },
    { text: 'Download gerado por', value: 'nomeUsuario', sortable: false },
    { text: 'Nome grupo repasse', value: 'nomeGrupoRepasse', sortable: false },
    { text: 'Fonte pagadora', value: 'fontePagadora', sortable: false },
    { text: 'Situação NF', value: 'situacao', sortable: false },
    { text: 'Mês referência', value: 'anoMesReferencia', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Ação', value: 'acao', align: 'center', sortable: false },
  ]

  public notasFiscaisTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Grupo de repasse', align: 'center', value: 'grupoRepasseNome', sortable: false },
    { text: 'Fonte pagadora', align: 'center', value: 'fontePagadora', sortable: false },
    { text: 'Contas a pagar', align: 'center', value: 'numeroContasPagar', sortable: true },
    { text: 'Responsável', align: 'center', value: 'responsavelNome', sortable: true },
    { text: 'Empresa médica', align: 'center', value: 'empresaMedicaNome', sortable: true },
    { text: 'Valor da nota', align: 'center', value: 'valorNota', sortable: true },
    { text: 'Número da nota', align: 'center', value: 'numeroNotas', sortable: false },
    { text: 'Número do chamado', align: 'center', value: 'numeroChamado', sortable: false },
    { text: 'Ação', align: 'center', value: '', sortable: false },
    { text: 'Situação repasse', align: 'center', value: 'situacao', sortable: false },
    { text: '', align: 'center', value: 'historico', sortable: false },
  ]

  public backofficeVisualizarItensHeaders: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Nome paciente', value: 'paciente', sortable: false },
    { text: 'Nome profissional', value: 'profissionalNome', sortable: false },
    { text: 'Data realizada', value: 'dataRealizacao', sortable: false },
    { text: 'Função', value: 'funcaoDescricao', sortable: false },
    { text: 'Via', value: 'viaAcesso', sortable: false },
    { text: 'Qtde.', value: 'quantidade', sortable: false },
    { text: 'Valor profissional', value: 'valorBruto', sortable: false },
  ]

  public validacaoRepasseErrosHeader: any[] = [
    { text: 'Data', value: 'data', align: 'center', sortable: false },
    { text: 'Tipo.', value: 'tipo', align: 'center', sortable: false },
    { text: 'Mensagem', value: 'mensagem', align: 'center', sortable: false },
  ]

  public validacaoCargaErrosHeader: any[] = [
    { text: 'Código.', value: 'codigo', align: 'center', sortable: false },
    { text: 'Mensagem', value: 'mensagem', align: 'center', sortable: false },
  ]

  public backofficeFinanceiroGeracaoRepasseHeaders: any[] = [
    { text: 'Data geração', value: 'createdOn', align: 'center', sortable: false },
    { text: 'Usuário', value: 'createdByNome', align: 'center', sortable: false },
    { text: 'Estabelecimento', value: 'nomeEstabelecimento', align: 'center', sortable: false },
    { text: 'Competência', value: 'mesAnoCompetencia', align: 'center', sortable: false },
    { text: 'Qtde de repasses', value: 'totalRepasses', align: 'center', sortable: false },
    { text: 'Tipo', value: 'tipo', align: 'center', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Ação', value: 'acao', align: 'center', sortable: false },
  ]

  public backofficeFinanceiroGeracaoRepasseVisualizarHeaders: any[] = [
    { text: '', value: '', align: 'center', sortable: false },
    { text: 'Grupo de repasse', value: 'grupoRepasse', align: 'center', sortable: false },
    { text: 'Fonte Pagadora', value: 'fontePagadora', align: 'center', sortable: false },
    { text: 'Prestador', value: 'prestador', align: 'center', sortable: false },
    { text: 'Status', value: 'status', align: 'center', sortable: false },
    { text: 'Valor', value: 'valor', align: 'center', sortable: false },
  ]

  public backofficeFinanceiroGeracaoRepasseItensHeaders: any[] = [
    { text: '', value: '', align: 'center', sortable: false },
    { text: 'Profissional', value: 'profissional', align: 'center', sortable: false },
    { text: 'Função', value: 'funcao', align: 'center', sortable: false },
    { text: 'Tipo', value: 'tipo', align: 'center', sortable: false },
    { text: 'Origem', value: 'origemItem', align: 'center', sortable: false },
    { text: 'Código', value: 'codigo', align: 'center', sortable: false },
    { text: 'Descrição', value: 'descricao', align: 'center', sortable: false },
    { text: 'Convênio', value: 'convenio', align: 'center', sortable: false },
    { text: 'Numero atendimento', value: 'numeroAtendimento', align: 'center', sortable: false },
    { text: 'Data execução', value: 'dataExecucao', align: 'center', sortable: false },
    { text: 'Valor', value: 'valor', align: 'center', sortable: false },
    { text: 'Situação', value: 'situacao', align: 'center', sortable: false },
  ]

  public logsTableHeader: any[] = [
    { text: '', value: '', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Exception', value: 'exception', sortable: false },
    { text: 'Data', value: 'createOn', sortable: false },
  ]

  public search: string = ''
  public searchCodigo: string = ''
  public searchDescricao: string = ''
  public searchCodigoDebounce: string = ''
  public searchDescricaoDebounce: string = ''
  public anexos: any[] = []
  public deleteNotaFiscalId: string = ''
  public sortBy: string = ''

  @Mutation
  setDataPrazo(value: string) {
    this.dataPrazo = value
  }

  @Mutation
  setDataPrevisao(value: string) {
    this.dataPrevisao = value
  }

  @Mutation
  setActiveTab(tab: number) {
    this.activeTab = tab
  }

  @Mutation
  setAgrupamentoRpas(value: boolean) {
    this.agrupamentoRpas = value
  }

  @Mutation
  setNomePrestador(value: string) {
    this.nomePrestador = value
  }

  @Mutation
  setCodigoRegra(value: string) {
    this.codigoRegra = value
  }

  @Mutation
  setBuscaProducao(value: string) {
    this.buscaProducao = value
  }

  @Mutation
  setSortBy(value: string) {
    this.sortBy = value
  }

  @Mutation
  solicitacaoIdRepasse(value: string) {
    this.solicitacaoId = value
  }

  @Mutation
  setTemProcedimento(value: boolean) {
    this.temProcedimento = value
  }

  @Mutation
  clearSortByFilter() {
    this.sortBy = ''
  }

  @Mutation
  setNome(value: string) {
    this.nome = value
  }

  @Mutation
  setEquipeProfissionalId(value: string) {
    this.equipeProfissionalId = value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  setEquipesOptions(value: string[]) {
    this.equipesOptions = value
  }

  @Mutation
  setHospitaisOptions(value: string[]) {
    this.hospitaisOptions = value
  }

  @Mutation
  clearItensDoRepasse() {
    this.itensDoRepasse = { ...this.itensDoRepasseDefault }
  }

  @Mutation
  clearBackofficeProcedimentos() {
    this.backofficeProcedimentos = { ...this.backofficeProcedimentosDefault }
  }

  @Mutation
  setDeleteNotaFiscalId(value: string) {
    this.deleteNotaFiscalId = value
  }

  @Mutation
  clearDeleteNotaFiscalId() {
    this.deleteNotaFiscalId = ''
  }

  @Mutation
  setFilterDrawer(value: boolean) {
    this.filterDrawer = value
  }

  @Mutation
  setGeracaoDrawer(value: boolean) {
    this.geracaoDrawer = value
  }

  @Mutation
  setRelatorioId(value: string) {
    this.relatorioId = value
  }

  @Mutation
  setPessoaId(value: string) {
    this.pessoaId = value
  }

  @Mutation
  setImpostoId(value: string) {
    this.impostoId = value
  }

  @Mutation
  setAlicota(value: string) {
    this.alicota = value
  }

  @Mutation
  setvalorMinimoTributo(value: string) {
    this.valorMinimoTributo = value
  }

  @Mutation
  setFilterValidacaoEGeracaoRepasseDrawer(value: boolean) {
    this.filterValidacaoEGeracaoRepasseDrawer = value
  }

  @Mutation
  setFilterProcedimentosDescartadosDrawer(value: boolean) {
    this.filterProcedimentosDescartadosDrawer = value
  }

  @Mutation
  setAgrupamentoRepasse(value: any) {
    this.agrupamentoRepasse = value
  }

  @Mutation
  setExportarRegistros(value: any) {
    this.exportarRegistros = value
  }

  @Mutation
  setFinalizarProcessos(value: any) {
    this.finalizarProcessos = value
  }

  @Mutation
  setItensDoRepasse(value: any) {
    this.itensDoRepasse = value
  }

  @Mutation
  setRelatorioEmitido(value: any) {
    this.relatorioEmitido = value
  }

  @Mutation
  setDownloadTipoCarga(value: any) {
    this.downloadTipoCarga = value
  }

  @Mutation
  setNotaFiscalItem(value: any) {
    this.notaFiscalItem = value
  }

  @Mutation
  setNotaFIscalItemAnexo(value: any) {
    this.notaFiscalItem.nomeArquivoOriginal = value
  }

  @Mutation
  setIdForDeleteNotaFiscal(value: string) {
    this.idForDeleteNotaFiscal = value
  }

  @Mutation
  setRelatorioEmissaoId(value: string) {
    this.relatorioEmissaoId = value
  }

  @Mutation
  setDescarteId(value: string) {
    this.descarteId = value
  }

  @Mutation
  setValidacaoErros(value: any[]) {
    this.validacaoErros = value
  }

  @Mutation
  setItemsTabelaValidacao(value: any) {
    this.itemsTabelaValidacao = value
  }

  @Mutation
  setTabelasAMB(value: any) {
    this.tabelasAMB = value
  }

  @Mutation
  setItemsTabelaPreco(value: any[]) {
    this.itemsTabelaPreco = value
  }

  @Mutation
  setIsEdit(value: boolean) {
    this.isEdit = value
  }

  @Mutation
  setItemsTabelaPrecoDetails(value: any[]) {
    this.itemsTabelaPrecoDetails = value
  }

  @Mutation
  setItemsTabelaPrecoIndice(value: any[]) {
    this.itemsTabelaPrecoIndice = value
  }

  @Mutation
  setConveniosRegras(value: any[]) {
    this.itemsConveniosRegras = value
  }

  @Mutation
  setItemsTabelaAmb(value: any) {
    this.itemsTabelaAmb = value
  }

  @Mutation
  setItemsRegrasProfissional(value: any[]) {
    this.itemsRegrasProfissional = value
  }

  @Mutation
  setConvenioRegras(value: any) {
    this.convenioRegras = value
  }

  @Mutation
  setMultiplicador(value: any) {
    this.multiplicador = value
  }

  @Mutation
  setTipoAluguelPrestador(value: string) {
    this.tipoAluguelPrestador = value
  }

  @Mutation
  setValorAluguelPrestador(value: string) {
    this.valorAluguelPrestador = value
  }

  @Mutation
  setAnoMesReferenciaDownloadNotasFiscais(value: string) {
    this.anoMesReferenciaDownloadNotasFiscais = value
  }

  @Mutation
  setCreatedOnNFDe(value: string) {
    this.createdOnNFDe = value
  }

  @Mutation
  setCreatedOnNFAte(value: string) {
    this.createdOnNFAte = value
  }

  @Mutation
  setSituacoesDoRepasseDownloadNotasFiscais(value: string) {
    this.situacoesDoRepasseDownloadNotasFiscais = value
  }

  @Mutation
  setFontePagadoraIdDownloadNotasFiscais(value: string) {
    this.fontePagadoraIdDownloadNotasFiscais = value
  }

  @Mutation
  setGeradoPorDownloadNotasFiscais(value: string) {
    this.geradoPorDownloadNotasFiscais = value
  }

  @Mutation
  setUsuariosGeradoresDownload(value: any[]) {
    this.usuariosGeradoresDownload = value
  }

  @Mutation
  setGrupoRepasseDownloadNotasFiscais(value: string) {
    this.grupoRepasseDownloadNotasFiscais = value
  }

  @Mutation
  setProfissionalPontuacao(value: string) {
    this.profissionalPontuacao = value
  }

  @Mutation
  setProfissionalPontuacaoNome(value: string) {
    this.profissionalPontuacaoNome = value
  }

  @Mutation
  setPrestadorRepasse(value: any) {
    this.prestadorRepasse = value
  }

  @Mutation
  setFuncaoProfissionalExecutante(value: string) {
    this.funcaoProfissionalExecutante = value
  }

  @Mutation
  setConvenioRepasse(value: string) {
    this.convenioRepasse = value
  }

  @Mutation
  setPlanoRepasse(value: string) {
    this.planoRepasse = value
  }

  @Mutation
  setViaAcesso(value: string) {
    this.viaAcesso = value
  }

  @Mutation
  setMotivoInclusao(value: string) {
    this.motivoInclusao = value
  }

  @Mutation
  setObservacao(value: string) {
    this.observacao = value
  }

  @Mutation
  setUrgente(value: boolean) {
    this.urgente = !!value
  }

  @Mutation
  setExcelRepasse(value: any) {
    this.excelRepasse = value
  }

  @Mutation
  setNumeroAtendimento(value: string) {
    this.numeroAtendimento = value
  }

  @Mutation
  setHisProcedimento(value: string) {
    this.hisProcedimento = value
  }

  @Mutation
  setDataAtendimento(value: string) {
    this.dataAtendimento = value
  }

  @Mutation
  setCodigoItens(value: string) {
    this.codigoItens = value
  }

  @Mutation
  setItemAvulsoRepasse(value: any) {
    this.itemAvulsoRepasse = value
  }

  @Mutation
  setCodigoProcedimentoId(value: string) {
    this.codigoProcedimentoId = value
  }

  @Mutation
  setCentroDeCustoId(value: string) {
    this.centroDeCustoId = value
  }

  @Mutation
  setEquipeIdSelected(value: any) {
    this.equipeIdSelected = value
  }

  @Mutation
  setHospitalIdSelected(value: any) {
    this.hospitalIdSelected = value
  }

  @Mutation
  setPontuacaoSelected(value: any) {
    this.pontuacaoSelected = value
  }

  @Mutation
  setTransacaoFinanceiraId(value: string) {
    this.transacaoFinanceiraId = value
  }

  @Mutation
  setValorProcedimento(value: number) {
    this.valorProcedimento = value
  }

  @Mutation
  setQuantidade(value: number) {
    this.quantidade = value
  }

  @Mutation
  setNomePaciente(value: string) {
    this.nomePaciente = value
  }

  @Mutation
  setNumeroConta(value: string) {
    this.numeroConta = value
  }

  @Mutation
  setSeqProcedimentoHis(value: string) {
    this.seqProcedimentoHis = value
  }

  @Mutation
  setPontuacaoProfissional(value: any) {
    this.pontuacaoProfissional = value
  }

  @Mutation
  setPrestadorIdFilter(value: any) {
    this.prestadorIdFilter = value
  }

  @Mutation
  setTaxaAdm(value: any) {
    this.taxaAdm = value
  }

  @Mutation
  setValorDeReferencia(value: any) {
    this.valorDeReferencia = value
  }

  @Mutation
  setEmitirRelatorioEmLote(value: string[]) {
    this.emitirRelatorioEmLote = value
  }

  @Mutation
  setAplicarFatorAcomodacao(value: any) {
    this.aplicarFatorAcomodacao = value
  }

  @Mutation
  setIndiceAtualRegras(value: any) {
    this.indiceAtualRegras = value
  }

  @Mutation
  setTabelaReferencia(value: any) {
    this.tabelaReferencia = value
  }

  @Mutation
  setTabelaIndice(value: any) {
    this.tabelaIndice = value
  }

  @Mutation
  setItemsTabelaValidacaoTotal(total: number) {
    this.itemsTabelaValidacaoTotal = total
  }

  @Mutation
  setTotalGeracaoDeRepasseVisualizar(total: number) {
    this.totalGeracaoDeRepasseVisualizar = total
  }

  @Mutation
  setTotalProcedimentosDescartados(total: number) {
    this.totalProcedimentosDescartados = total
  }

  @Mutation
  clearAgrupamentoRepasse() {
    this.agrupamentoRepasse = { ...this.agrupamentoRepasseDefault }
  }

  @Mutation
  setGerarRepassePrestadores(value: any[]) {
    this.gerarRepassePrestadores = value
  }

  @Mutation
  setStatusList(value: any[]) {
    this.statusList = value
  }

  @Mutation
  setSelectedPrestador(value: any) {
    this.selectedPrestador = value
  }

  @Mutation
  setSelectedTipo(value: any[]) {
    if (this.selectedTipo.includes(value)) {
      this.selectedTipo.splice(this.selectedTipo.indexOf(value), 1)
    } else {
      this.selectedTipo.push(value)
    }
  }

  @Mutation
  setSelectedStatus(value: any[]) {
    if (this.selectedStatus.includes(value)) {
      this.selectedStatus.splice(this.selectedStatus.indexOf(value), 1)
    } else {
      this.selectedStatus.push(value)
    }
  }

  @Mutation
  setFontePagadora(value: any[]) {
    this.fontePagadoras = value
  }

  @Mutation
  setCondicaoPagamento(value: any[]) {
    this.condicoesPagamento = value
  }

  @Mutation
  setFontePagadoraId(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setGrupoRepasseId(value: string) {
    this.grupoRepasseId = value
  }

  @Mutation
  setSituacoesExportarRegistros(value: string) {
    this.situacoesExportarRegistros = value
  }

  @Mutation
  setFontePagadoraIdFinalizarProcessos(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setFontePagadoraGerarRepasse(value: string) {
    this.fontePagadoraId = value
  }

  @Mutation
  setEstabelecimentoGerarRepasse(value: string) {
    this.estabelecimentoGerarRepasseId = value
  }

  @Mutation
  setPrestadorGerarRepasse(value: string) {
    this.prestadorGerarRepasse = value
  }

  @Mutation
  setCondicaoPagamentoGerarRepasseId(value: string) {
    this.condicaoPagamentoGerarRepasseId = value
  }

  @Mutation
  setGrupoRepasseExportarRegistros(value: string) {
    this.grupoRepasse = value
  }

  @Mutation
  setGrupoRepasseFinalizarProcessos(value: string) {
    this.grupoRepasseFinalizarProcessos = value
  }

  @Mutation
  setLayoutRelatorio(value: boolean | null) {
    this.layoutRelatorio = value
  }

  @Mutation
  clearLayoutRelatorio() {
    this.layoutRelatorio = null
  }

  @Mutation
  setNumeroChamado(value: string) {
    this.numeroChamado = value
  }

  @Mutation
  setEmail(value: string) {
    this.email = value
  }

  @Mutation
  setNumeroRepasse(value: string) {
    this.numeroRepasse = value
  }

  @Mutation
  setContasPagar(value: string) {
    this.contasPagar = value
  }

  @Mutation
  setNumeroNota(value: string) {
    this.numeroNota = value
  }

  @Mutation
  setValorNota(value: string) {
    this.valorNota = value
  }

  @Mutation
  setCodigoRepasse(value: string) {
    this.codigoRepasse = value
  }

  @Mutation
  setPodeEncerrarRepasses(value: boolean) {
    this.enablePodeEncerrarRepasses = value
  }

  @Mutation
  setExibirOpcaoRelatorioAssinaturaDiretoria(value: boolean) {
    this.exibirOpcaoRelatorioAssinaturaDiretoria = value
  }

  @Mutation
  setSomatorioTotalNotas(value: number) {
    this.somatorioTotalNotas = value
  }

  @Mutation
  setGrupoRepasse(value: string) {
    this.grupoRepasse = value
  }

  @Mutation
  setAnoMesCompetencia(value: string) {
    this.anoMesCompetencia = value
  }

  @Mutation
  setAnoMesReferencia(value: string) {
    // O clearable do campo devolve null ao limpar; normaliza para '' porque outras telas comparam
    // este estado com string vazia (ex.: RemuneracaoRightNavBar.hasAnyFilter).
    this.anoMesReferencia = value || ''
  }

  @Mutation
  setTransacaoUnica(value: boolean) {
    this.transacaoUnica = value
  }

  @Mutation
  setAnoMesReferenciaDe(value: string) {
    this.anoMesReferenciaDe = value
  }

  @Mutation
  setAnoMesReferenciaAte(value: string) {
    this.anoMesReferenciaAte = value
  }

  @Mutation
  setCompetenciaFaturamento(value: string) {
    this.competenciaFaturamentoAnoMes = value
  }

  @Mutation
  setCompetenciaRepasse(value: string) {
    this.competenciaRepasseAnoMes = value
  }

  @Mutation
  setAnoMesReferenciaListaRepasse(value: string) {
    this.anoMesReferenciaListaRepasse = value
  }

  @Mutation
  setAnoMesReferenciaExportarRegistros(value: string) {
    this.anoMesReferenciaExportarRegistros = value
  }

  @Mutation
  setRelatorioSelected(value: string) {
    this.relatorioSelected = value
  }

  @Mutation
  setAnoMesReferenciaFinalizarProcessos(value: string) {
    this.anoMesReferenciaFinalizarProcessos = value
  }

  @Mutation
  setAnoMesReferenciaGeracaoRepasse(value: string) {
    this.anoMesReferenciaGeracaoRepasse = value
  }

  @Mutation
  setAnoMesReferenciaDoRepasse(value: string) {
    this.anoMesReferenciaDoRepasse = value
  }

  @Mutation
  setDataEnvioNotaFiscalGeracaoRepasse(value: string) {
    this.dataEnvioNotaFiscalGeracaoRepasse = value
  }

  @Mutation
  setDataVencimentoGeracaoRepasse(value: string) {
    this.dataVencimentoGeracaoRepasse = value
  }

  @Mutation
  setAnoMesReferenciaRecalcularValores(value: string) {
    this.anoMesReferenciaRecalcularValores = value
  }

  @Mutation
  setPrazoRecalcularValores(value: string) {
    this.prazoRecalcularValores = value
  }

  @Mutation
  setDataRecebimentoRecalcularValores(value: string) {
    this.dataRecebimentoRecalcularValores = value
  }

  @Mutation
  setAluguelPrestadorId(value: string) {
    this.aluguelPrestadorId = value
  }

  @Mutation
  setModal(modal: { name: string; value: any; context?: string }) {
    this.modal[modal.name] = modal.value
    this.modalContext = modal.context || null
  }

  @Mutation
  setDisabledConfirmar(value: boolean) {
    this.disabledConfirmar = value
  }

  @Mutation
  setIsNewNotaFiscal(value: boolean) {
    this.isNewNotaFiscal = value
  }

  @Mutation
  setSituacoes(value: string) {
    if (this.situacoes.includes(value)) {
      this.situacoes.splice(this.situacoes.indexOf(value), 1)
    } else {
      this.situacoes.push(value)
    }
  }

  @Mutation
  setFuncoes(value: string) {
    if (this.funcoes.includes(value)) {
      this.funcoes.splice(this.funcoes.indexOf(value), 1)
    } else {
      this.funcoes.push(value)
    }
  }

  @Mutation
  setStatusGeracaoRepasse(value: string | string[] | any) {
    if (this.statusGeracaoRepasse.includes(value)) {
      this.statusGeracaoRepasse.splice(this.statusGeracaoRepasse.indexOf(value), 1)
    } else if (isArray(value)) {
      this.statusGeracaoRepasse = value
    } else {
      this.statusGeracaoRepasse.push(value)
    }
  }

  @Mutation
  setFontePagadoraFilter(value: string) {
    this.fontePagadoraFilter = value
  }

  @Mutation
  setGeracaoProfissionalFilter(value: string) {
    this.geracaoProfissionalFilter = value
  }

  @Mutation
  setGeracaoPrestadorFilter(value: string) {
    this.geracaoPrestadorFilter = value
  }

  @Mutation
  setGeracaoProfissionaisOptions(value: any[]) {
    this.geracaoProfissionaisOptions = value
  }

  @Mutation
  setGeracaoPrestadoresOptions(value: any[]) {
    this.geracaoPrestadoresOptions = value
  }

  @Mutation
  setTipoItens(value: string) {
    this.tipoItens = value
  }

  @Mutation
  setApenasDivergentes(value: boolean) {
    this.apenasDivergente = value
  }

  @Mutation
  setAlterarFuncao(value: string) {
    this.alterarFuncao = value
  }

  @Mutation
  clearAlterarFuncao() {
    this.alterarFuncao = ''
  }

  @Mutation
  setSituacoesValidacao(value: string) {
    if (this.situacoesValidacao.includes(value)) {
      this.situacoesValidacao.splice(this.situacoesValidacao.indexOf(value), 1)
    } else {
      this.situacoesValidacao.push(value)
    }
  }

  @Mutation
  setErrosValidacao(value: string) {
    if (this.errosValidacao.includes(value)) {
      this.errosValidacao.splice(this.errosValidacao.indexOf(value), 1)
    } else {
      this.errosValidacao.push(value)
    }
  }

  @Mutation
  setErrosCarga(value: string) {
    if (this.errosCarga.includes(value)) {
      this.errosCarga.splice(this.errosCarga.indexOf(value), 1)
    } else {
      this.errosCarga.push(value)
    }
  }

  @Mutation
  setSearch(value: string) {
    this.search = value
  }

  @Mutation
  setSearchCodigo(value: string) {
    this.searchCodigo = value
  }

  @Mutation
  setSearchDescricao(value: string) {
    this.searchDescricao = value
  }

  @Mutation
  setSearchCodigoDebounce(value: string) {
    this.searchCodigoDebounce = value
  }

  @Mutation
  setSearchDescricaoDebounce(value: string) {
    this.searchDescricaoDebounce = value
  }

  @Mutation
  setPrestadoresRecebimentos(value: PrestadorRecebimento[]) {
    this.prestadoresRecebimentos = value
  }

  @Mutation
  setAcoesItemRecebimento(value: any) {
    this.acoesItemRecebimento = value
  }

  @Mutation
  setListaColunasOcultar(value: any[]) {
    this.colunasOcultarItems = value
  }

  @Mutation
  setGeracaoDeRepassesItems(value: any[]) {
    this.geracaoDeRepassesItems = value
  }

  @Mutation
  setPrestadorId(value: any) {
    this.prestadorId = value
  }

  @Mutation
  setPrestadorNome(value: any) {
    this.prestadorNome = value
  }

  @Mutation
  setProfissionalRepasse(value: any) {
    this.profissionalRepasse = value
  }

  @Mutation
  setNomeProfissionalRepasse(value: any) {
    this.nomeProfissionalRepasse = value
  }

  @Mutation
  setMedicoRecebimentoId(value: any) {
    this.medicoRecebimentoIds = value
  }

  @Mutation
  setGeracaoDeRepassesItemsVisualizar(value: any[]) {
    this.geracaoDeRepassesItemsVisualizar = value
  }

  @Mutation
  setProcedimentosDescartados(value: any[]) {
    this.procedimentosDescartados = value
  }

  @Mutation
  setProcedimentosDescarteRecriacao(value: any[]) {
    this.procedimentosDescarteRecriacao = value
  }

  @Mutation
  setTotalProcedimentosDescarteRecriacao(value: any) {
    this.totalProcedimentosDescarteRecriacao = value
  }

  @Mutation
  setCargasVisualizarItems(value: any[]) {
    this.cargasVisualizarItems = value
  }

  @Mutation
  setAcoesGeracaoRepasse(value: any) {
    this.acoesGeracaoRepasse = value
  }

  @Mutation
  setAcoesItensDoRepasse(value: any) {
    this.acoesItensDoRepasse = value
  }

  @Mutation
  setDadosGeraisDoRepasse(value: any) {
    this.dadosGeraisDoRepasse = value
  }

  @Mutation
  setGeracaoDeRepassesItemsPrestador(value: any[]) {
    this.geracaoDeRepassesItemsPrestador = value
  }

  @Mutation
  setDescontosPrestador(value: any[]) {
    this.descontosPrestador = value
  }

  @Mutation
  deleteItemsFromGeracaoDeRepassesItemsPrestador(medicoRecebimentoIds: string[]) {
    medicoRecebimentoIds.forEach((id: string) => {
      const index = this.geracaoDeRepassesItemsPrestador.findIndex((item: any) => item.medicoRecebimentoId === id)
      if (index !== -1) {
        this.geracaoDeRepassesItemsPrestador.splice(index, 1)
      }
    })
  }

  @Mutation
  setPontuacoes(value: any[]) {
    this.pontuacoes = value
  }

  @Mutation
  setProcedimentos(value: any[]) {
    this.codigoProcedimento = value
  }

  @Mutation
  clearProcedimentos() {
    this.codigoProcedimento = [...this.codigoProcedimentoDefault]
  }

  @Mutation
  setTransacaoFinanceira(value: any[]) {
    this.transacaoFinanceira = value
  }

  @Mutation
  clearTransacaoFinanceira() {
    this.transacaoFinanceira = [...this.transacaoFiananceiraDefault]
  }

  @Mutation
  setCentroDeCusto(value: any[]) {
    this.centroDeCusto = value
  }

  @Mutation
  clearCentroDeCusto() {
    this.centroDeCusto = [...this.centroDeCustoDefault]
  }

  @Mutation
  setItemsCargaRemuneracao(value: ItemsCargaRemuneracao[]) {
    this.itemsCargaRemuneracao = value
  }

  @Mutation
  setCriadoresCarga(value: any[]) {
    this.criadoresCarga = value
  }

  @Mutation
  setFiltroCargaPeriodoDe(value: string) {
    this.filtroCargaPeriodoDe = value
  }

  @Mutation
  setFiltroCargaPeriodoAte(value: string) {
    this.filtroCargaPeriodoAte = value
  }

  @Mutation
  setFiltroCargaCriadoPor(value: string) {
    this.filtroCargaCriadoPor = value
  }

  @Mutation
  setFiltroCargaTipo(value: string) {
    this.filtroCargaTipo = value
  }

  @Mutation
  setFiltroCargaNomeArquivo(value: string) {
    this.filtroCargaNomeArquivo = value
  }

  @Mutation
  setFiltroCargaStatus(value: string) {
    this.filtroCargaStatus = value
  }

  @Mutation
  setFiltroCargaTemErro(value: string) {
    this.filtroCargaTemErro = value
  }

  @Mutation
  limparFiltroCarga() {
    this.filtroCargaPeriodoDe = ''
    this.filtroCargaPeriodoAte = ''
    this.filtroCargaCriadoPor = ''
    this.filtroCargaTipo = ''
    this.filtroCargaNomeArquivo = ''
    this.filtroCargaStatus = ''
    this.filtroCargaTemErro = ''
  }

  @Mutation
  setItemsDownloadNotasFiscais(value: any[]) {
    this.itemsDownloadNotasFiscais = value
  }

  @Mutation
  setTotalItemsDownloadNotasFiscais(value: number) {
    this.totalItemsDownloadNotasFiscais = value
  }

  @Mutation
  setTabelasDeReferencia(value: TabelasDeReferencia[]) {
    this.tabelasDeReferencia = value
  }

  @Mutation
  setItemsRecebimentoMonitor(value: any) {
    this.itensRecebimentoMonitor = value
  }

  @Mutation
  setRepassesCarregados(value: any) {
    this.repassesCarregados = value
  }

  @Mutation
  setTotalItensRepassesCarregados(value: any) {
    this.totalItensRepassesCarregados = value
  }

  @Mutation
  setItensRecebimentoErros(value: any) {
    this.itensRecebimentoErros = value
  }

  @Mutation
  setBackofficeProducao(value: BackofficeProducao[]) {
    this.backofficeProducao = value
  }

  @Mutation
  setCargaLogs(logs: CargaRemuneracaoLog[]) {
    this.cargaLogs = logs
  }

  @Mutation
  setLogsPrestadorRecebimento(logs: any[]) {
    this.logsPrestadorRecebimento = logs
  }

  @Mutation
  setTotalRecebimentoErros(total: number) {
    this.total = total
  }

  @Mutation
  setPrestadorRecebimento(value: PrestadorRecebimento) {
    this.prestadorRecebimento = value
  }

  @Mutation
  setDocumentoId(value: any) {
    this.documentoId = value
  }

  @Mutation
  setNotaFiscalUnica(value: any) {
    this.notaFiscalUnica = value
  }

  @Mutation
  setBackofficeProcedimentos(value: Procedimentos[]) {
    this.backofficeProcedimentos = value
  }

  @Mutation
  setTemplateNotificarConfig(value: TemplateNotificarConfig) {
    this.templateNotificarConfig = value
  }

  @Mutation
  clearPrestadoresRecebimentos() {
    this.prestadoresRecebimentos = [...this.prestadoresRecebimentosDefault]
  }

  @Mutation
  clearPrestadorRecebimento() {
    this.prestadorRecebimento = { ...this.prestadorRecebimentoDefault }
  }

  @Mutation
  clearTemplateNotificarConfig() {
    this.templateNotificarConfig = { ...this.templateNotificarConfigDefault }
  }

  @Mutation
  clearSituacoes() {
    this.situacoes = []
  }

  @Mutation
  clearFuncoes() {
    this.funcoes = []
  }

  @Mutation
  clearAdvancedFilters() {
    this.numeroAtendimento = ''
    this.codigoItens = ''
    this.tipoItens = ''
    this.convenios = ''
    this.profissionais = ''
    this.anoMesReferenciaDe = ''
    this.anoMesReferenciaAte = ''
    this.selectedPeriodo = ''
    this.selectedProfissionalExecutante = ''
    this.profissionais = ''
  }

  @Mutation
  clearProcedimentosDescartadosFilter() {
    this.numeroAtendimento = ''
    this.codigoItens = ''
    this.hisProcedimento = ''
    this.selectedPrestador = ''
    this.anoMesReferenciaDe = ''
    this.anoMesReferenciaAte = ''
    this.profissionais = ''
    this.convenios = ''
  }

  @Mutation
  clearFilterValidacaoEGeracaoRepasse() {
    this.selectedStatus = []
    this.selectedPrestador = ''
    this.selectedProfissionalExecutante = ''
    this.profissionaisExecutantes = []
  }

  @Mutation
  clearFilterGeracaoRepasse() {
    this.selectedTipo = []
    this.anoMesReferencia = ''
    // statusGeracaoRepasse fica de fora: a tela nasce com um default em beforeMount (esconde as
    // gerações descartadas) e zerar aqui traria elas de volta.
    this.fontePagadoraFilter = ''
    this.geracaoProfissionalFilter = ''
    this.geracaoPrestadorFilter = ''
    this.geracaoProfissionaisOptions = []
    this.geracaoPrestadoresOptions = []
    this.geracaoFilterOn = false
  }

  @Mutation
  clearSearch() {
    this.search = ''
  }

  @Mutation
  clearSearchCodigo() {
    this.searchCodigo = ''
  }

  @Mutation
  setSituacoesCount(situacoes: any) {
    this.situacoesFiltro = situacoes
  }

  @Mutation
  setFuncoesFiltro(funcoes: any) {
    this.funcoesFiltro = funcoes.map((f: any) => f.funcao)
  }

  @Mutation
  setTiposCarga(data: any[]) {
    this.tiposCarga = data
  }

  @Mutation
  setTipoCargaSelected(data: string) {
    this.tipoCargaSelected = data
  }

  @Mutation
  setPagina(pag: number) {
    this.pagina = pag
  }

  @Mutation
  setPaginaRepassesCarregados(pag: number) {
    this.paginaRepassesCarregados = pag
  }

  @Mutation
  setPaginaValidacaoEGeracao(pag: number) {
    this.paginaValidacaoEGeracao = pag
  }

  @Mutation
  setPaginaGeracao(pag: number) {
    this.paginaGeracao = pag
  }

  @Mutation
  setIdForLoadValidacaoEGeracaoRepasse(id: string) {
    this.idForLoadValidacaoEGeracaoRepasse = id
  }

  @Mutation
  setTipoGeracaoRepasse(value: string) {
    this.tipoGeracaoRepasse = value
  }

  @Mutation
  setIdForCloseGeracao(id: string) {
    this.idForCloseGeracao = id
  }

  @Mutation
  setIdForLoadProcedimentosDescartados(id: string) {
    this.idForLoadProcedimentosDescartados = id
  }

  @Mutation
  setPaginaProcedimentosDescarteRecriacao(pag: number) {
    this.paginaProcedimentosDescarteRecriacao = pag
  }

  @Mutation
  podeLiberarRepasse(value: string) {
    this.podeLiberar = value
  }

  @Mutation
  podeDescartarRepasse(value: boolean) {
    this.podeDescartar = value
  }

  @Mutation
  setIdForLoadItensRepasse(id: string) {
    this.idForLoadItensRepasse = id
  }

  @Mutation
  setPrestadorIdRecalculo(id: string) {
    this.idPrestadorRecalculo = id
  }

  @Mutation
  setGeracaoRepasseId(id: string) {
    this.idGeracaoRepasse = id
  }

  @Mutation
  setIdForLoadPrestadores(id: string) {
    this.idForLoadPrestadores = id
  }

  @Mutation
  setPrestadorRecebimentoId(id: string) {
    this.prestadorRecebimentoId = id
  }

  @Mutation
  setStatusGeracaoDeRepasse(status: string) {
    this.statusGeracaoDeRepasse = status
  }

  @Mutation
  setIdForLoadItemAvulso(id: string) {
    this.idForLoadItemAvulso = id
  }

  @Mutation
  setPageItems(pag: number) {
    this.pageItems = pag
  }

  @Mutation
  setPaginaProducao(pag: number) {
    this.paginaProducao = pag
  }

  @Mutation
  clearPagePagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  fillAllSituacoes() {
    this.situacoes = [
      'Pendente',
      'Divergente',
      'ValidacaoPendente',
      'Validada',
      'Paga',
      'Provisionada',
      'EnviadoParaPagamento',
    ]
  }

  @Mutation
  setTotalPrestadorRemuneracao(total: number) {
    this.totalPrestadorRemuneracao = total
  }

  @Mutation
  setExibirNumeroChamado(total: boolean) {
    this.exibirNumeroChamado = total
  }

  @Mutation
  setTotalGeracaoDeRepasse(total: number) {
    this.totalGeracaoDeRepasse = total
  }

  @Mutation
  setCalculoAtivo(value: boolean) {
    this.calculoAtivo = value
  }

  @Mutation
  setTipoEnum(value: any) {
    this.tipoEnum = value
  }

  @Mutation
  setTotalItensPrestador(total: number) {
    this.totalItensPrestador = total
  }

  @Mutation
  setValorTotal(total: number) {
    this.valorTotal = total
  }

  @Mutation
  setQuantidadeTotal(total: number) {
    this.quantidadeTotal = total
  }

  @Mutation
  setTotalItemsCargaRemuneracao(total: number) {
    this.totalItemsCargaRemuneracao = total
  }

  @Mutation
  setProfissionaisExecutantes(value: any[]) {
    this.profissionaisExecutantes = value
    this.profissionaisList = value
  }

  @Mutation
  setAllProfissionais(value: any[]) {
    this.allProfissionaisList = value
  }

  @Mutation
  setTipoItensList(value: any[]) {
    this.tipoItensList = value
  }

  @Mutation
  setPrestadoresRepasse(value: any[]) {
    this.prestadoresRepasse = value
  }

  @Mutation
  setStatusGeracaoRepasseFiltro(value: any[]) {
    this.statusGeracaoRepasseFiltro = value
  }

  @Mutation
  setFuncoesProfissionalExecutante(value: any[]) {
    this.funcoesProfissionalExecutante = value
  }

  @Mutation
  setConveniosRepasse(value: any[]) {
    this.conveniosRepasse = value
    this.conveniosList = value
  }

  @Mutation
  setPlanosRepasse(value: any[]) {
    this.planosRepasse = value
  }

  @Mutation
  setViasAcesso(value: any[]) {
    this.viasAcesso = value
  }

  @Mutation
  clearProfissionaisExecutantes() {
    this.profissionaisExecutantes = [...this.profissionaisExecutantesDefault]
  }

  @Mutation
  clearPrestadoresRepasse() {
    this.prestadoresRepasse = []
  }

  @Mutation
  clearFuncoesProfissionalExecutante() {
    this.funcoesProfissionalExecutante = []
  }

  @Mutation
  clearDadosAlterarPrestador() {
    this.profissionaisExecutantes = []
    this.profissionalPontuacao = ''
    this.profissionalPontuacaoNome = ''
    this.profissionalRepasse = ''
    this.selectedProfissionalExecutante = ''
    this.profissionais = ''
  }

  @Mutation
  clearConveniosRepasse() {
    this.conveniosRepasse = []
  }

  @Mutation
  clearPlanosRepasse() {
    this.planosRepasse = []
  }

  @Mutation
  clearViasAcesso() {
    this.viasAcesso = []
  }

  @Mutation
  setMotivosInclusao(value: any[]) {
    this.motivosInclusaoItemAvulso = value
  }

  @Mutation
  clearMotivosInclusao() {
    this.motivosInclusaoItemAvulso = [...this.motivosInclusaoItemAvulsoDefault]
  }

  @Mutation
  setConvenio(value: any) {
    this.convenio = value
  }

  @Mutation
  setProfissionais(value: any) {
    this.profissionais = value
  }

  @Mutation
  setConvenios(value: any) {
    this.convenios = value
  }

  @Mutation
  setOperadoraId(value: any) {
    this.operadoraId = value
  }

  @Mutation
  setTabelaId(value: any) {
    this.tabelaId = value
  }

  @Mutation
  setItemUpdateId(value: any) {
    this.itemUpdateId = value
  }

  @Mutation
  setProfissionalRegrasId(value: any) {
    this.profissionalRegrasId = value
  }

  @Mutation
  setFontePagadoraRegrasId(value: any) {
    this.fontePagadoraRegrasId = value
  }

  @Mutation
  setCodigoTuss(value: any) {
    this.codigoTuss = value
  }

  @Mutation
  setCodigoAMB(value: any) {
    this.codigoAMB = value
  }

  @Mutation
  setMedicoProducaoProcedimentoId(value: any) {
    this.medicoProducaoProcedimentoId = value
  }

  @Mutation
  setDescricaoTuss(value: any) {
    this.descricaoTuss = value
  }

  @Mutation
  setTabelaAmbId(value: any) {
    this.tabelaAmbId = value
  }

  @Mutation
  setTotalItensDoRepasse(total: number) {
    this.totalRepasseItems = total
  }

  @Mutation
  setItemsId(value: string) {
    this.itemsId = value
  }

  @Mutation
  setTotalTabelaDeReferencia(total: number) {
    this.totalTabelaDeReferencia = total
  }

  @Mutation
  setTotalBackofficeProducao(total: number) {
    this.totalBackofficeProducao = total
  }

  @Mutation
  setTotalPageBackofficeProducao(total: number) {
    this.totalPageBackofficeProducao = total
  }

  @Mutation
  clearDocumento() {
    this.prestadorRecebimento.nomeArquivoOriginal = ''
  }

  @Mutation
  setNomeArquivoOriginal(nome: string) {
    this.prestadorRecebimento.nomeArquivoOriginal = nome
  }

  @Mutation
  setFilterOn(value: boolean) {
    this.filterOn = value
  }

  @Mutation
  setGeracaoFilterOn(value: boolean) {
    this.geracaoFilterOn = value
  }

  @Mutation
  setFiltroValorPontuacao(value: string) {
    this.filtroValorPontuacao = value
  }

  @Mutation
  setFiltroCodigoPontuacaoOuNome(value: string) {
    this.filtroCodigoPontuacaoOuNome = value
  }

  @Mutation
  setFiltroHospitalId(value: string) {
    this.filtroHospitalId = value
  }

  @Mutation
  setFiltroEquipeProfissional(value: string) {
    this.filtroEquipeProfissional = value
  }

  @Mutation
  setResumoEquipeMedica(value: any) {
    this.equipesMedicas = value
  }

  @Mutation
  clearGeracaoRepasses() {
    this.fontePagadoraId = ''
    this.condicaoPagamentoGerarRepasseId = ''
    this.anoMesReferenciaGeracaoRepasse = ''
    this.dataVencimentoGeracaoRepasse = ''
    this.dataEnvioNotaFiscalGeracaoRepasse = ''
    this.estabelecimentoGerarRepasseId = ''
    this.prestadorGerarRepasse = ''
    this.anoMesReferenciaDoRepasse = ''
  }

  @Mutation
  clearFiltro() {
    this.grupoRepasse = ''
    this.anoMesReferencia = ''
    this.fontePagadoraId = ''
    this.numeroChamado = ''
    this.numeroRepasse = ''
    this.numeroNota = ''
    this.valorNota = ''
    this.contasPagar = ''
    this.profissional = ''
  }

  @Mutation
  clearFiltroValidacao() {
    this.codigoTuss = ''
    this.competenciaFaturamentoAnoMes = ''
    this.fontePagadoraId = ''
  }

  @Mutation
  atualizaStatusParaProvisionada(prestadorRecebimentoId: string) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === prestadorRecebimentoId) {
        temp.situacao.display = SituacaoRemuneracaoEnum.Provisionada
        temp.situacao.key = SituacaoRemuneracaoEnum.Provisionada
        temp.acoes.podeProvisionar = false
        temp.acoes.atualizar = false
        temp.acoes.podeCancelarProvisionamento = true
        temp.acoes.podeDeletarNotaFiscal = false
        temp.acoes.visualizar = false
      }
      return temp
    })
  }

  @Mutation
  atualizaStatusParaPendente(prestadorRecebimentoId: string) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === prestadorRecebimentoId) {
        temp.situacao.display = SituacaoRemuneracaoEnum.Pendente
        temp.situacao.key = SituacaoRemuneracaoEnum.Pendente
        temp.acoes.podeProvisionar = true
        temp.acoes.atualizar = true
        temp.acoes.podeCancelarProvisionamento = false
        temp.acoes.podeDeletarNotaFiscal = false
        temp.acoes.visualizar = false
      }
      return temp
    })
  }

  @Mutation
  atualizaDataPrevisaoPagamento(params: any) {
    const index = this.prestadoresRecebimentos.findIndex((e: any) => e.id === params.prestadorRecebimentoId)
    this.prestadoresRecebimentos[index].dataPrevisaoPagamento = params.novaPrevisaoRecebimento
  }

  @Mutation
  atualizarAcaoPodeProvisionar(prestadorRecebimentoId: string) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === prestadorRecebimentoId) {
        temp.acoes.podeProvisionar = true
      }
      return temp
    })
  }

  @Mutation
  atualizarDataNotificacao(params: any) {
    this.prestadoresRecebimentos.map((c) => {
      const temp = c
      if (temp.id === params.prestadorRecebimentoId) {
        temp.dataUltimaNotificacao = params.dataNotificacaoManual
      }
      return temp
    })
  }

  @Mutation
  setGrupoRepasseItens(itens: any[]) {
    this.grupoRepasseItens = itens
  }

  @Mutation
  setItemsMonitoramentoCargas(value: any[]) {
    this.itemsMonitoramentoCargas = value
  }

  @Mutation
  setTipoFilter(value: any) {
    this.tipoFilter = value
  }

  @Mutation
  setStatusFilter(value: any) {
    this.statusFilter = value
  }

  @Mutation
  setTotalItemsMonitoramentoCargas(value: number) {
    this.totalItemsMonitoramentoCargas = value
  }

  @Mutation
  setItemRepasse(item: any) {
    this.itemRepasse = item
  }

  @Mutation
  setGrupoRepasseItensAll(itens: any[]) {
    this.grupoRepasseItensAll = itens
  }

  @Mutation
  setPrestadoresLista(value: PrestadoresRecebimentoSearch[]) {
    this.prestadoresLista = value
  }

  @Mutation
  setPrestadoresListaImposto(lista: any[]) {
    const mapped = (lista || []).map(p => {
      const semNome = !p || !p.nome
      const semId = !p || !p.userId

      if (semNome || semId) {
        return {
          userId: '',
          nome: TAXA_PADRAO,
          documento: p && p.documento ? p.documento : '',
          codHis: p && p.codHis ? p.codHis : ''
        }
      }

      return {
        ...p,
        codHis: p.codHis || ''
      }
    })

    const resultado = [{ userId: '', nome: TAXA_PADRAO, documento: '', codHis: '' }, ...mapped]

    this.prestadoresLista = resultado
  }

  @Mutation
  setImpostoPrestadorList(value: any[]) {
    this.impostoPrestadorList = value
  }

  @Mutation
  setIdForSaveAlterarPrestador(value: string) {
    this.idForSaveAlterarPrestador = value
  }

  @Mutation
  setIdDesfazerRepasse(value: string) {
    this.idForDesfazerRepasse = value
  }

  @Mutation
  clearPrestadoresLista() {
    this.prestadoresLista = [...this.prestadoresListaDefault]
  }

  @Mutation
  setMensagemLogDesfazer(value: string) {
    this.mensagemLogDesfazer = value
  }

  @Mutation
  setSelectedProfissionalExecutante(value: string) {
    this.selectedProfissionalExecutante = value
  }

  @Mutation
  setProfissional(value: string) {
    this.profissional = value
  }

  @Mutation
  setDataExecucaoDe(value: string) {
    this.dataExecucaoDe = value
  }

  @Mutation
  setDataExecucaoAte(value: string) {
    this.dataExecucaoAte = value
  }

  @Mutation
  setCodigo(value: string) {
    this.codigo = value
  }

  @Mutation
  setPeriodos(value: any[]) {
    this.periodos = value
  }

  @Mutation
  setTotalIntegracaoGeralRepasses(value: number) {
    this.totalIntegracaoGeralRepasses = value
  }

  @Mutation
  setIntegracaoGeralRepasses(value: any[]) {
    this.integracaoGeralRepasses = value
  }

  @Mutation
  setSelectedPeriodo(value: string) {
    this.selectedPeriodo = value
  }

  @Mutation
  setLoadingTipoItens(value: boolean) {
    this.loadingTipoItens = value
  }

  @Mutation
  setLoadingProfissionais(value: boolean) {
    this.loadingProfissionais = value
  }

  @Mutation
  setLoadingFuncoesProfissionalExecutante(value: boolean) {
    this.loadingFuncoesProfissionalExecutante = value
  }

  @Mutation
  setConfigsParametrosAplicacao(value: any) {
    this.configsParametrosAplicacao = value
  }

  @Mutation
  setTipoRelatorio(value: string){
    this.tipoRelatorio = value
  }
  
  @Action
  async downloadArquivosCargaRemuneracao(id: string) {
    try {
      const response = await this.remuneracaoMedica.downloadArquivosCargaRemuneracao(id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async downloadCargasGeracao(id: string) {
    try {
      const response = await this.remuneracaoMedica.downloadCargasGeracao(id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getRepassesCarregados(id: string) {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      importacaoArquivoId: id,
    }
    try {
      const response = await this.remuneracaoMedica.getRepassesCarregados(params)
      if (response.success) {
        this.context.commit('setRepassesCarregados', response.data.itens)
        this.context.commit('setTotalItensRepassesCarregados', response.data.totalRegistros)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsRecebimentoMonitor(recebimentoId: string) {
    try {
      const response = await this.remuneracaoMedica.getItemsRecebimentoMonitor(recebimentoId)
      if (response.success) {
        this.context.commit('setItemsRecebimentoMonitor', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsRecebimentoErros(recebimentoId: number) {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        recebimentoId,
      }
      const response = await this.remuneracaoMedica.getItemsRecebimentoErros(params)
      if (response.success) {
        this.context.commit('setItensRecebimentoErros', response.data.itens)
        this.context.commit('setTotalRecebimentoErros', response.data.totalRegistros)
        this.context.commit('setPagination', { page: this.pagina, rowsPerPage: this.qtdPorPagina, totalItems: response.data.totalRegistros })
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelasDeReferencia() {
    const response = await this.remuneracaoMedica.getTabelasDeReferencia()
    if (response.success) {
      this.context.commit('setTabelasDeReferencia', response.data)
      this.context.commit('setPagination', { ...this.pagination, totalItems: response.data.length })
      this.context.commit('setTotalTabelaDeReferencia', response.data.length)
    }

    return response
  }

  @Action
  async criarTabelaPreco() {
    try {
      const { itemTabelaPreco, itemTabelaReferenciaId } = this

      const {
        nome,
        equipeProfissionalId,
        hospitalId,
        pontuacaoId
      } = itemTabelaPreco || {}

      const params: any = {
        id: itemTabelaReferenciaId,
        nome,
        equipeProfissionalId,
        hospitalId,
        pontuacaoId
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key]
        }
      })

      const response = await this.remuneracaoMedica.criarTabelaPreco(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getBackofficeProducao() {
    const params: any = {
      pagina: this.paginaProducao,
      qtdPorPagina: this.qtdPorPagina,
      filtroTexto: this.buscaProducao,
    }

    const response = await this.remuneracaoMedica.getBackofficeProducao(params)
    if (response.success) {
      this.context.commit('setBackofficeProducao', response.data.producoes)
      this.context.commit('setTotalBackofficeProducao', response.data.totalRegistros)
      this.context.commit('setTotalPageBackofficeProducao', response.data.totalPaginas)
      const procedimentos = response.data.procedimentos
        ? response.data.procedimentos
        : []
      this.context.commit('setBackofficeProcedimentos', procedimentos)
    }

    return response
  }

  @Action
  async getItemsCargaRemuneracaoAll() {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      sortBy: this.sortBy,
      periodoDe: this.filtroCargaPeriodoDe,
      periodoAte: this.filtroCargaPeriodoAte,
      criadoPor: this.filtroCargaCriadoPor,
      tipo: this.filtroCargaTipo,
      nomeArquivo: this.filtroCargaNomeArquivo,
      status: this.filtroCargaStatus,
      temErro: this.filtroCargaTemErro,
    }

    const response = await this.remuneracaoMedica.getItemsCargaRemuneracaoAll(params)
    if (response.success) {
      this.context.commit('setItemsCargaRemuneracao', response.data.arquivos)
      this.context.commit('setTiposCarga', response.data.tiposCarga)
      this.context.commit('setTotalItemsCargaRemuneracao', response.data.totalRegistros)
      this.context.commit('setTransacaoUnica', !!response.data.cargaRepasseTransacaoUnica)
      this.context.commit('setNaoCarregarPrestadorComCalculo', !!response.data.cargaNaoCarregarPrestadorComCalculo)
    }
    return this.itemsCargaRemuneracao
  }

  @Action
  async getCriadoresCarga() {
    const response = await this.remuneracaoMedica.getCriadoresCarga()
    if (response.success) {
      this.context.commit('setCriadoresCarga', response.data)
    }
    return this.criadoresCarga
  }

  @Action
  async filtrarCargaRemuneracao() {
    this.context.commit('setPagina', 1)
    return this.getItemsCargaRemuneracaoAll()
  }

  @Action
  async limparFiltroCargaRemuneracao() {
    this.context.commit('limparFiltroCarga')
    this.context.commit('setPagina', 1)
    return this.getItemsCargaRemuneracaoAll()
  }

  @Action
  async getItemsDownloadNotasFiscais() {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      anoMesReferencia: this.anoMesReferenciaDownloadNotasFiscais,
      fontePagadoraId: this.fontePagadoraIdDownloadNotasFiscais,
      grupoRepasse: this.grupoRepasseDownloadNotasFiscais,
      situacao: this.situacoesDoRepasseDownloadNotasFiscais,
      geradoPorId: this.geradoPorDownloadNotasFiscais,
    }

    seqDownloadNotasFiscais += 1
    const seq = seqDownloadNotasFiscais

    const response = await this.remuneracaoMedica.getItemsDownloadNotasFiscais(params)
    // Descarta resposta fora de ordem: só a busca mais recente pode escrever no estado.
    if (seq !== seqDownloadNotasFiscais) return this.itemsDownloadNotasFiscais

    if (response.success) {
      this.context.commit('setItemsDownloadNotasFiscais', response.data.itens)
      this.context.commit('setTotalItemsDownloadNotasFiscais', response.data.totalRegistros)
    }
    return this.itemsDownloadNotasFiscais
  }

  @Action
  async getUsuariosGeradoresDownload() {
    const response = await this.remuneracaoMedica.getUsuariosGeradoresDownloadNotas()
    if (response.success) {
      this.context.commit('setUsuariosGeradoresDownload', response.data || [])
    }
    return response
  }

  @Action
  async getPrestadorRemuneracaoAll() {
    const params: any = {
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      situacoes: this.situacoes,
      grupoRepasse: this.grupoRepasse,
      anoMesReferencia: this.anoMesReferencia,
      fontePagadoraId: this.fontePagadoraId,
      numeroChamado: this.numeroChamado,
      numeroRepasse: this.numeroRepasse,
      somatorioTotalNotas: this.somatorioTotalNotasDefault,
      contasPagar: this.contasPagar,
      valornota: this.valorNota,
      numeroNota: this.numeroNota,
      sortBy: this.sortBy,
      nome: this.nomePrestador,
      profissionalId: this.profissional
    }

    const response = await this.remuneracaoMedica.getPrestadorRecebimentoAll(params)
    if (response.success) {
      this.context.commit('setPrestadoresRecebimentos', response.data.remuneracoes)
      this.context.commit('setListaColunasOcultar', response.data.listaColunasOcultar)
      this.context.commit('setSituacoesCount', response.data.situacoes)
      this.context.commit('setTotalPrestadorRemuneracao', response.data.total)
      this.context.commit('setExibirNumeroChamado', response.data.exibirNumeroChamado)
      this.context.commit('setGrupoRepasseItens', response.data.gruposRepasse)
      this.context.commit('setExibirOpcaoRelatorioAssinaturaDiretoria', response.data.exibirOpcaoRelatorioAssinaturaDiretoria)
      this.context.commit('setPodeEncerrarRepasses', response.data.podeEncerrarRepasses)

      const indexHeaderResponsavel = this.notasFiscaisTableHeader.findIndex(header => header.value === 'responsavelNome')
      this.notasFiscaisTableHeader[indexHeaderResponsavel].text = this.profissional ? 'Profissional' : 'Responsável'

      const indexHeaderProfissionalModalItens = this.backofficeVisualizarItensHeaders.findIndex(header => header.value == 'profissionalNome')
      this.backofficeVisualizarItensHeaders[indexHeaderProfissionalModalItens].text = this.profissional ? 'Profissional' : 'Nome profissional'
    }

    return this.prestadoresRecebimentos
  }

  @Action
  async getTiposCarga() {
    try {
      const response = await this.remuneracaoMedica.getTiposCarga()
      if (response.success) {
        this.context.commit('setTiposCarga', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsMonitoramentoCargas(filtros: FiltrosRecebimentoMonitor = {}) {
    seqMonitoramentoCargas += 1
    const seq = seqMonitoramentoCargas

    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        tipoEnum: this.search,
        statusEnum: filtros.statusEnum,
        nomeUsuario: filtros.nomeUsuario,
        dataInicio: filtros.dataInicio,
        dataFim: filtros.dataFim,
      }

      const request = await this.remuneracaoMedica.getItemsMonitoramentoCargas(params)

      // Descarta resposta fora de ordem: so a busca mais recente pode escrever no estado.
      if (request.success && seq === seqMonitoramentoCargas) {
        this.context.commit('setItemsMonitoramentoCargas', request.data.itens)
        this.context.commit('setTotalItemsMonitoramentoCargas', request.data.totalRegistros)
      }

      return request
    } catch (error) {
      if (seq === seqMonitoramentoCargas) {
        this.context.commit('setItemsMonitoramentoCargas', [])
      }

      return { success: false, message: error }
    }
  }

  @Action
  async getTipoFilter() {
    try {
      const response = await this.remuneracaoMedica.getTipoFilter()
      if (response.success) {
        this.context.commit('setTipoFilter', response.data)
      }

      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getStatusFilter() {
    try {
      const response = await this.remuneracaoMedica.getStatusFilter()
      if (response.success) {
        this.context.commit('setStatusFilter', response.data)
      }

      return response
    } catch (error) {
      return { success: false, message: error }
    }
  }

  @Action
  async getTiposCargaDownload() {
    try {
      const response = await this.remuneracaoMedica.getTiposCargaDownload()
      if (response.success) {
        this.context.commit('setTiposCarga', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async alterarSituacoesEmLote() {
    try {
      const params: any = {
        grupoRepasseId: this.grupoRepasseFinalizarProcessos || null,
        anoMesReferencia: this.anoMesReferenciaFinalizarProcessos ? `${this.anoMesReferenciaFinalizarProcessos}-01` : null,
        fontePagadoraId: this.fontePagadoraId || null,
      }
      const response = await this.remuneracaoMedica.alterarSituacoesEmLote(params)
      if (response.success) this.context.commit('setFinalizarProcessos', response.data)
      return response
    } catch (error) {
      return { message: 'Não foi finalizar os repasses.' }
    }
  }

  @Action
  async saveAluguelPrestador() {
    try {
      const params: any = {
        prestadorId: this.idForSaveAlterarPrestador,
        tipo: this.tipoAluguelPrestador,
        valor: this.valorAluguelPrestador === undefined ? 0 : +this.valorAluguelPrestador,
      }

      if (this.fontePagadoraId) {
        params.fontePagadoraId = this.fontePagadoraId
      }

      const request = await this.remuneracaoMedica.saveAluguelPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveAlterarPontuacaoProfissional() {
    const params: any = {
      profissionalId: this.profissionalPontuacao,
      pontuacaoId: this.pontuacaoProfissional,
    }
    const response = await this.remuneracaoMedica.saveAlterarPontuacaoProfissional(params)
    return response
  }

  @Action
  async saveNovoItemAvulsoRepasse() {
    try {
      const procedimento: any = this.codigoProcedimento.find((e: any) => e.id === this.codigoProcedimentoId)
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItemAvulso,
        valor: this.valorProcedimento === undefined ? 0 : +this.valorProcedimento,
        turno: null,
        profissionalExecutanteId: this.profissionalPontuacao || null,
        codigoProcedimento: procedimento ? procedimento.codigo : null,
        descricaoProcedimento: procedimento ? procedimento.descricao : null,
        nomePaciente: this.nomePaciente,
        dataRealizacao: `${new Date(this.dataAtendimento).toISOString().split('T')[0]}T00:00:00`,
        numeroConta: this.numeroConta,
        identificadorHisProducaoProcedimento: this.seqProcedimentoHis,
        quantidade: this.quantidade,
        convenioId: this.convenioRepasse || null,
        planoId: this.planoRepasse || null,
        viaAcesso: this.viaAcesso || null,
        funcao: this.funcaoProfissionalExecutante || null,
        numeroAtendimento: this.numeroAtendimento,
        observacao: this.observacao,
        urgente: this.urgente,
        transacaoFinanceiraId: this.transacaoFinanceiraId || null,
        centroDeCustoId: this.centroDeCustoId || null,
        motivoInclusaoAvulsoId: this.motivoInclusao || null,
      }
      const response = await this.remuneracaoMedica.saveNovoItemAvulsoRepasse(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveInsercaoDeRegistrosEmLoteCalcularRepasse({ formData, context }) {
    try {
      const formDataToSend = new FormData()

      formDataToSend.append('anexo', formData)
      formDataToSend.append('geracaoRepasseId', this.idForLoadValidacaoEGeracaoRepasse)
      formDataToSend.append('prestadorRecebimentoId', context === 'cargaGeracao' ? String(null) : String(this.idForLoadItemAvulso))
      formDataToSend.append('transacaoFinanceiraId', this.transacaoFinanceiraId || '')
      formDataToSend.append('centroDeCustoId', this.centroDeCustoId || '')
      formDataToSend.append('motivoInclusaoId', this.motivoInclusao || '')
      formDataToSend.append('observacao', this.observacao)
      formDataToSend.append('tipo', 'GeracaoRepasseCargaProducaoProcedimento')

      const response = await this.remuneracaoMedica.saveInsercaoDeRegistrosEmLoteCalcularRepasse(formDataToSend)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveItensFixosCargaPlanilha({ formData, context }) {
    try {
      const formDataToSend = new FormData()

      formDataToSend.append('anexo', formData)
      formDataToSend.append('geracaoRepasseId', this.idForLoadValidacaoEGeracaoRepasse)
      formDataToSend.append('prestadorRecebimentoId', context === 'cargaGeracao' ? String(null) : String(this.idForLoadItemAvulso))
      formDataToSend.append('transacaoFinanceiraId', this.transacaoFinanceiraId || '')
      formDataToSend.append('centroDeCustoId', this.centroDeCustoId || '')
      formDataToSend.append('motivoInclusaoId', this.motivoInclusao || '')
      formDataToSend.append('observacao', this.observacao)
      formDataToSend.append('tipo', 'GeracaoRepasseCargaProducaoProcedimentoFixo')

      const response = await this.remuneracaoMedica.saveInsercaoDeRegistrosEmLoteCalcularRepasse(formDataToSend)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveNovoItemAvulsoCalcularRepasse() {
    try {
      const procedimento: any = this.codigoProcedimento.find((e: any) => e.id === this.codigoProcedimentoId)
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItemAvulso,
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
        valor: this.valorProcedimento === undefined ? 0 : +this.valorProcedimento,
        turno: null,
        profissionalExecutanteId: this.profissionalPontuacao || null,
        codigoProcedimento: procedimento ? procedimento.codigo : null,
        descricaoProcedimento: procedimento ? procedimento.descricao : null,
        nomePaciente: this.nomePaciente,
        dataRealizacao: `${new Date(this.dataAtendimento).toISOString().split('T')[0]}T00:00:00`,
        codigoHisContaPaciente: this.numeroConta,
        identificadorHisProducaoProcedimento: this.seqProcedimentoHis,
        quantidade: this.quantidade,
        convenioId: this.convenioRepasse || null,
        planoId: this.planoRepasse || null,
        viaAcesso: this.viaAcesso || null,
        funcao: this.funcaoProfissionalExecutante || null,
        numeroAtendimento: this.numeroAtendimento,
        observacao: this.observacao,
        urgente: this.urgente,
        transacaoFinanceiraId: this.transacaoFinanceiraId || null,
        centroDeCustoId: this.centroDeCustoId || null,
        motivoInclusaoAvulsoId: this.motivoInclusao || null,
      }
      const response = await this.remuneracaoMedica.saveNovoItemAvulsoCalcularRepasse(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async saveAlterarPrestador() {
    try {
      const params: any = {
        profissionalExecutanteId: this.profissionalPontuacao,
        prestadorRecebimentoId: this.prestadorId,
        medicoRecebimentoIds: this.medicoRecebimentoIds,
        prestadorId: this.prestadorRepasse.prestadorId,
        contratoId: this.prestadorRepasse.contratoId,
      }
      const response = await this.remuneracaoMedica.saveAlterarPrestador(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getFontePagadoraAll() {
    const response = await this.remuneracaoMedica.getFontePagadoraAll()
    if (response.success) {
      this.context.commit('setFontePagadora', response.data)
    }

    return response
  }

  @Action
  async getTipoItens() {
    try {
      const request = await this.remuneracaoMedica.getTipoItens()
      if (request.success) {
        this.context.commit('setTipoItensList', request.success ? request.data : [])
      }
      return request
    } catch (error) {
      this.context.commit('setTipoItensList', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    } finally {
      this.context.commit('setLoadingTipoItens', false)
    }
  }

  @Action
  async getGerarRepassePrestadores(param: any) {
    try {
      const response = await this.remuneracaoMedica.getGerarRepassePrestadores(param)
      if (response.success) {
        this.context.commit('setGerarRepassePrestadores', response.data.itens)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getStatusList() {
    try {
      const response = await this.remuneracaoMedica.getStatusList()
      if (response.success) {
        this.context.commit('setStatusList', response.data)
      }
      return response
    } catch (error) {
      this.context.commit('setStatusList', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async gerarRepasses(estabelecimentoId?: any) {
    try {
      let params = {}

      if (!estabelecimentoId) {
        params = {
          geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse || null
        }
      } else {
        params = {
          fontePagadoraId: estabelecimentoId ? estabelecimentoId : this.fontePagadoraId,
          estabelecimentoId: estabelecimentoId ? estabelecimentoId : this.estabelecimentoGerarRepasseId,
          prestadorId: this.prestadorGerarRepasse || null,
          condicaoPagamentoId: this.condicaoPagamentoGerarRepasseId || null,
          mesAnoCompetencia: this.anoMesReferenciaGeracaoRepasse ? `${this.anoMesReferenciaGeracaoRepasse}-01` : null,
          mesReferencia: this.anoMesReferenciaDoRepasse ? `${this.anoMesReferenciaDoRepasse}-01` : null,
          dataVencimento: this.dataVencimentoGeracaoRepasse || null,
          prazoEnvioNF: this.dataEnvioNotaFiscalGeracaoRepasse || null,
        }
      }

      const response = await this.remuneracaoMedica.gerarRepasses(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getProfissionais(nome?: any) {
    try {
      const params = {
        nome: nome ? nome : this.profissionalPontuacaoNome,
      }

      const request = await this.remuneracaoMedica.getProfissionais(params)
      this.context.commit('setProfissionaisExecutantes', request.success ? request.data.pessoas : [])
      return request
    } catch (error) {
      this.context.commit('setProfissionaisExecutantes', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  // FXSR-2689 — combos dos filtros da listagem de gerações. Listas próprias para não disputar
  // profissionaisExecutantes/gerarRepassePrestadores com as telas de dentro da geração.
  @Action
  async getGeracaoProfissionaisByNome(nome: string) {
    try {
      const request = await this.remuneracaoMedica.getProfissionais({ nome })
      this.context.commit('setGeracaoProfissionaisOptions', request.success ? request.data.pessoas : [])
      return request
    } catch (error) {
      this.context.commit('setGeracaoProfissionaisOptions', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getGeracaoPrestadoresByNome(filtro: string) {
    try {
      const request = await this.remuneracaoMedica.getPessoaPrestadorAll({ limite: 20, filtro: encodeURIComponent(filtro) })
      this.context.commit('setGeracaoPrestadoresOptions', request.success && request.data.prestadores ? request.data.prestadores : [])
      return request
    } catch (error) {
      this.context.commit('setGeracaoPrestadoresOptions', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  // Busca profissionais executantes por nome, restritos à geração selecionada (endpoint específico).
  @Action
  async getProfissionaisExecutantesByGeracao(nome?: string) {
    const geracaoRepasseId = this.idForLoadValidacaoEGeracaoRepasse
    if (!geracaoRepasseId) return { success: false }
    try {
      const request = await this.remuneracaoMedica.getProfissionaisExecutantesByGeracao({ geracaoRepasseId, nome })
      this.context.commit('setProfissionaisExecutantes', request.success ? request.data.pessoas : [])
      return request
    } catch (error) {
      this.context.commit('setProfissionaisExecutantes', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getAllProfissionais() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const request = await this.remuneracaoMedica.getAllProfissionais(params)
      this.context.commit('setAllProfissionais', request.success ? request.data.itens : [])
      return request
    } catch (error) {
      this.context.commit('setAllProfissionais', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    } finally {
      this.context.commit('setLoadingProfissionais', false)
    }
  }

  @Action
  async getPrestadoresRepasse() {
    try {
      const params: any = {
        fontePagadoraId: this.idForLoadPrestadores || null,
        profissionalId: this.profissionalRepasse || null,
      }
      const request = await this.remuneracaoMedica.getPrestadoresRepasse(params)
      this.context.commit('setPrestadoresRepasse', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setPrestadoresRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getFuncoesProfissionalExecutante() {
    try {
      const request = await this.remuneracaoMedica.getFuncoesProfissionalExecutante()
      this.context.commit('setFuncoesProfissionalExecutante', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setFuncoesProfissionalExecutante', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    } finally {
      this.context.commit('setLoadingFuncoesProfissionalExecutante', false)
    }
  }

  @Action
  async getConveniosRepasse() {
    const params: any = {
      nome: null,
    }
    try {
      const request = await this.remuneracaoMedica.getConveniosRepasse(params)
      this.context.commit('setConveniosRepasse', request.success ? request.data.convenios : [])
      return request
    } catch (error) {
      this.context.commit('setConveniosRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPlanosRepasse() {
    const params: any = {
      convenioId: this.convenioRepasse || null,
    }
    try {
      const request = await this.remuneracaoMedica.getPlanosRepasse(params)
      this.context.commit('setPlanosRepasse', request.success ? request.data.itens : [])
      return request
    } catch (error) {
      this.context.commit('setPlanosRepasse', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getViasAcesso() {
    try {
      const request = await this.remuneracaoMedica.getViasAcesso()
      this.context.commit('setViasAcesso', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setViasAcesso', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getMotivoInclusao() {
    try {
      const request = await this.remuneracaoMedica.getMotivoInclusao()
      this.context.commit('setMotivosInclusao', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setMotivosInclusao', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getCondicaoPagamentoAll() {
    const response = await this.remuneracaoMedica.getCondicaoPagamento()
    if (response.success) {
      this.context.commit('setCondicaoPagamento', response.data.itens)
    }

    return response
  }

  @Action
  async getGeracaoRepasseAll() {
    const params: any = {
      pagina: this.paginaGeracao,
      qtdPorPagina: this.qtdPorPagina,
      status: this.statusGeracaoRepasse,
      tipo: this.selectedTipo,
      estabelecimentoId: this.fontePagadoraFilter,
      mesAnoCompetencia: this.anoMesReferencia ? `${this.anoMesReferencia}-01` : null,
      // A API rejeita profissional/prestador sem competência (FXSR-2690); o front já bloqueia os
      // campos, aqui só não enviamos o filtro órfão.
      profissionalId: this.anoMesReferencia ? this.geracaoProfissionalFilter : '',
      prestadorId: this.anoMesReferencia ? this.geracaoPrestadorFilter : '',
    }

    const response = await this.remuneracaoMedica.getGeracaoRepasse(params)
    if (response.success) {
      this.context.commit('setGeracaoDeRepassesItems', response.data.itens)
      this.context.commit('setTotalGeracaoDeRepasse', response.data.totalRegistros)
      this.context.commit('setCalculoAtivo', response.data.calculoAtivo)
    }
    return response
  }

  @Action
  async getTipoEnum() {
    try {
      const response = await this.remuneracaoMedica.getTipoEnum()
      if (response.success) {
        this.context.commit('setTipoEnum', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getGeracaoDeRepasseItensPrestador(prestadorId: string) {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        id: this.aluguelPrestadorId,
        funcoes: this.funcoes,
        tipo: this.tipoItens,
        numeroAtendimento: this.numeroAtendimento,
        codigo: this.codigoItens,
        operadoraId: this.convenios,
        profissionalId: this.profissionais ? this.profissionais : this.selectedProfissionalExecutante,
        dataExecucaoDe: this.anoMesReferenciaDe,
        dataExecucaoAte: this.anoMesReferenciaAte,
        apenasDivergente: this.apenasDivergente,
        prestadorRecebimentoId: prestadorId,
        turno: this.selectedPeriodo
      }
      const response = await this.remuneracaoMedica.getGeracaoDeRepasseItensPrestador(params)
      if (response.success) {
        this.context.commit('setGeracaoDeRepassesItemsPrestador', response.data.itens)
        this.context.commit('setAcoesItensDoRepasse', response.data.acoes)
        this.context.commit('setTotalItensPrestador', response.data.totalRegistros)
        this.context.commit('setValorTotal', response.data.valorTotal)
        this.context.commit('setQuantidadeTotal', response.data.quantidadeTotal)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async alterarFuncaoGeracaoRepasse() {
    try {
      const params: any = {
        producaoProcedimentoIds: this.itemRepasse,
        novaFuncao: this.alterarFuncao,
      }
      const response = await this.remuneracaoMedica.alterarFuncaoGeracaoRepasse(params)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao alterar' }
    }
  }

  @Action
  async getAllDescontosPrestador(id: string) {
    try {
      const params: any = {
        prestadorId: id,
      }
      const response = await this.remuneracaoMedica.getAllDescontosPrestador(params)
      if (response.success) {
        this.context.commit('setDescontosPrestador', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getProfissionalPontuacao() {
    try {
      const params: any = {
        profissionalId: this.profissionalPontuacao,
      }
      const response = await this.remuneracaoMedica.getProfissionalPontuacao(params)

      if (response.success) {
        this.context.commit('setPontuacaoProfissional', this.pontuacoes.find((e: any) => e.id === response.data.itens[0].pontuacaoId))
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getPontuacaoProfissional() {
    const response = await this.remuneracaoMedica.getPontuacaoProfissional()
    if (response.success) {
      this.context.commit('setPontuacoes', response.data.itens)
    }
  }

  @Action
  async getProcedimentos() {
    try {
      const request = await this.remuneracaoMedica.getProcedimentos()
      this.context.commit('setProcedimentos', request.success ? request.data.procedimentos : [])
      return request
    } catch (error) {
      this.context.commit('setProcedimentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getValidacaoErros() {
    try {
      const param: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const request = await this.remuneracaoMedica.getValidacaoErros(param)
      this.context.commit('setValidacaoErros', request.success ? request.data.itens : [])
      return request
    } catch (error) {
      this.context.commit('setValidacaoErros', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getTransacaoFinanceira() {
    try {
      const request = await this.remuneracaoMedica.getTransacaoFinanceira()
      this.context.commit('setTransacaoFinanceira', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setTransacaoFinanceira', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getCentroDeCusto() {
    try {
      const request = await this.remuneracaoMedica.getCentroDeCusto()
      this.context.commit('setCentroDeCusto', request.success ? request.data : [])
      return request
    } catch (error) {
      this.context.commit('setCentroDeCusto', [])
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getConvenio() {
    try {
      const response = await this.remuneracaoMedica.getConvenio()
      if (response.success) this.context.commit('setConvenio', response.data.convenios)
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar convênios.' }
    }
  }

  @Action
  async getRegistrosValidacao() {
    const params: any = {
      prestadorId: this.prestadorId,
      fontePagadoraId: this.fontePagadoraId,
      nomePaciente: this.nomePaciente,
      operadoraId: this.operadoraId,
      planoOperadoraId: this.planoOperadoraId,
      profissionalExecutanteId: this.profissionais,
      codigoTuss: this.codigoTuss,
      competenciaFaturamentoAnoMes: this.competenciaFaturamentoAnoMes ? `${this.competenciaFaturamentoAnoMes}-01` : this.competenciaFaturamentoAnoMes,
      competenciaRepasseAnoMes: this.competenciaRepasseAnoMes ? `${this.competenciaRepasseAnoMes}-01` : this.competenciaRepasseAnoMes,
      codigoHisRegra: this.codigoRepasse,
      situacao: this.situacoesValidacao,
      erros: this.errosValidacao,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const response = await this.remuneracaoMedica.getRegistrosValidacao(params)
    if (response.success) {
      this.context.commit('setItemsTabelaValidacao', response.data.itens)
      this.context.commit('setItemsTabelaValidacaoTotal', response.data.totalRegistros)
    }

    return response
  }

  @Action
  async fecharGeracaoRepasse() {
    try {
      const params: any = {
        ids: [
          this.idForCloseGeracao,
        ],
      }
      const response = await this.remuneracaoMedica.fecharGeracaoRepasse(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getGeracaoDeRepassesItemsVisualizar(id: string) {
    const params: any = {
      id,
      prestadorId: this.selectedPrestador,
      statusRepasse: this.selectedStatus,
      pagina: this.paginaValidacaoEGeracao,
      qtdPorPagina: this.qtdPorPagina,
      profissionalId: this.selectedProfissionalExecutante
    }
    const response = await this.remuneracaoMedica.getGeracaoDeRepassesItemsVisualizar(params)
    if (response.success) {
      this.context.commit('setGeracaoDeRepassesItemsVisualizar', response.data.itens)
      this.context.commit('setAcoesGeracaoRepasse', response.data.acoes)
      this.context.commit('setDadosGeraisDoRepasse', response.data)
      this.context.commit('setAluguelPrestadorId', id)
      this.context.commit('setTotalGeracaoDeRepasseVisualizar', response.data.totalRegistros)
    }
    return response
  }

  @Action
  async getDescontosPrestadorRecebimento(params: { geracaoRepasseId: string; prestadorRecebimentoId: string }) {
    return this.remuneracaoMedica.getPrestadorRecebimentoDescontos(params)
  }

  @Action
  async getCargasVisualizarItems() {
    const params: any = {
      id: this.idForLoadValidacaoEGeracaoRepasse,
    }
    const response = await this.remuneracaoMedica.getCargasVisualizarItems(params)
    if (response.success) {
      const itensOrderByCreatedOn = response.data.sort((a: any, b: any) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())
      this.context.commit('setCargasVisualizarItems', itensOrderByCreatedOn)
    }
    return response
  }

  @Action
  async getProcedimentosDescarteRecriacao() {
    const params: any = {
      id: this.idForLoadValidacaoEGeracaoRepasse,
      prestadorId: this.selectedPrestador,
      profissionalExecutanteId: this.selectedProfissionalExecutante,
      identificadorHis: this.hisProcedimento,
      numeroAtendimento: this.numeroAtendimento,
      codigo: this.codigo,
      dataExecucaoDe: this.dataExecucaoDe,
      dataExecucaoAte: this.dataExecucaoAte,
      pagina: this.paginaProcedimentosDescarteRecriacao,
    }
    const response = await this.remuneracaoMedica.getProcedimentosDescarteRecriacao(params)
    if (response.success) {
      this.context.commit('setProcedimentosDescarteRecriacao', response.data.itens)
      this.context.commit('setTotalProcedimentosDescarteRecriacao', response.data.totalRegistros)
    }
    return response
  }

  @Action
  async getProcedimentosDescartados() {
    try {
      const params: any = {
        id: this.idForLoadProcedimentosDescartados,
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        prestadorId: this.selectedPrestador,
        identificadorHis: this.hisProcedimento,
        numeroAtendimento: this.numeroAtendimento,
        codigo: this.codigoItens,
        profissionalExecutanteId: this.profissionais,
        operadoraId: this.convenios,
        dataExecucaoDe: this.anoMesReferenciaDe,
        dataExecucaoAte: this.anoMesReferenciaAte,
      }
      const response = await this.remuneracaoMedica.getProcedimentosDescartados(params)
      if (response.success) {
        this.context.commit('setProcedimentosDescartados', response.data.itens)
        this.context.commit('setTotalProcedimentosDescartados', response.data.totalRegistros)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na sua requisição!' }
    }
  }

  @Action
  async salvarCodigoAmb() {
    const params: any = {
      medicoProducaoProcedimentoId: this.medicoProducaoProcedimentoId,
      codigoAMB: this.codigoAMB,
    }
    try {
      const response = await this.remuneracaoMedica.salvarCodigoAmb(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelasAMB() {
    try {
      const response = await this.remuneracaoMedica.getTabelasAMB()
      this.context.commit('setTabelasAMB', response.data.itens)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async updateItemTabelaAmb() {
    const params: any = {
      id: this.itemUpdateId,
      codigoAMB: this.codigoAMB,
      codigoTuss: this.codigoTuss,
      descricaoTuss: this.descricaoTuss,
      tabelaAMBId: this.tabelaAmbId,
    }
    try {
      const response = await this.remuneracaoMedica.updateItemTabelaAmb(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async saveEditTableRules() {
    const params: any = {
      codigoHisRegra: this.codigoRepasse || null,
      id: this.itemUpdateId || null,
      profissionalId: this.profissionalRegrasId || null,
      operadoraId: this.convenioRegras || null,
      fontePagadoraId: this.fontePagadoraRegrasId || null,
      fatorRegra: this.multiplicador || null,
      percentualTaxaAdministrativa: this.taxaAdm || null,
      valorDeReferencia: this.valorDeReferencia || null,
      aplicarFatorAcomodacao: this.aplicarFatorAcomodacao || null,
      tabelaPrecoId: this.tabelaReferencia || null,
      tabelaIndiceId: this.tabelaIndice || null,
      tabelaIndiceAtual: this.indiceAtualRegras || null,
    }
    try {
      const response = await this.remuneracaoMedica.saveEditTableRules(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async createItemTabelaAmb() {
    const params: any = {
      codigoAMB: this.codigoAMB,
      codigoTuss: this.codigoTuss,
      descricaoTuss: this.descricaoTuss,
      tabelaAMBId: this.tabelaAmbId,
    }
    try {
      const response = await this.remuneracaoMedica.updateItemTabelaAmb(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteItemTabelaAmb() {
    try {
      const response = await this.remuneracaoMedica.deleteItemTabelaAmb(this.itemUpdateId)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsTabelaAMB() {
    const params: any = {
      tabelaAmbId: this.tabelaId,
    }
    try {
      const response = await this.remuneracaoMedica.getItemsTabelaAMB(params)
      this.context.commit('setPagination', { ...this.pagination, totalItems: response.data.itens.length })
      this.context.commit('setItemsTabelaAmb', response.data.itens)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItemsRegrasProfissional() {
    const params: any = {
      codigoHisRegra: this.codigoRegra,
    }
    try {
      const response = await this.remuneracaoMedica.getItemsRegrasProfissional(params)
      this.context.commit('setItemsRegrasProfissional', response.data.regras)
      this.context.commit('setPagination', { ...this.pagination, totalItems: response.data.totalRegistros })
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaPrecoAll() {
    try {
      const response = await this.remuneracaoMedica.getTabelaPrecoAll()
      this.context.commit('setItemsTabelaPreco', response.data)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaPrecoDetails(pagina: number) {
    try {
      const params: any = {
        pagina,
        qtdPorPagina: this.qtdPorPagina,
        nome: this.nome,
        equipeProfissionalId: this.equipeProfissionalId,
        hospitalId: this.hospitalId
      }
      const response = await this.remuneracaoMedica.getTabelaPrecoDetails(params)
      this.context.commit('setItemsTabelaPrecoDetails', response.data.itens)
      this.context.commit('setItemsTabelaPrecoDetailsPagina', response.data.paginaAtual || 1)
      this.context.commit('setItemsTabelaPrecoDetailsTotal', response.data.totalRegistros || 0)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async deleteItemTabelaPreco(id: number) {
    try {
      const response = await this.remuneracaoMedica.deleteItemTabelaPreco(id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getTabelaPrecoIndice() {
    try {
      const response = await this.remuneracaoMedica.getTabelaPrecoIndice()
      this.context.commit('setItemsTabelaPrecoIndice', response.data.indices)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getConvenioRegras() {
    try {
      const response = await this.remuneracaoMedica.getConvenioRegras()
      this.context.commit('setConveniosRegras', response.data.convenios)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getVisualizarRecebimento(prestadorRecebimentoId: string) {
    try {
      const response = await this.remuneracaoMedica.getRecebimentoNotaFiscalById(prestadorRecebimentoId)
      if (response.success) {
        this.context.commit('setPrestadorRecebimento', response.data)
        this.context.commit('setNotaFiscalUnica', response.data.notasFiscais[0])
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async geRecebimentoById(prestadorRecebimentoId: string) {
    const response = await this.remuneracaoMedica.getRecebimentoNotaFiscalById(prestadorRecebimentoId)
    if (response.success) {
      if (response.data.notaFiscalModoUpload.key === 'Unica') {
        if (response.data.notasFiscais.length) {
          this.context.commit('setDocumentoId', response.data.notasFiscais[0].documentoId)
        }
        this.setModal({ name: 'atualizarNotaFiscal', value: true })
      } else {
        this.setModal({ name: 'multiplasNotasFiscais', value: true })
      }

      if (!response.data.dataRecebimentoNota) {
        response.data.dataRecebimentoNota = ''
      }

      if (!response.data.divergencia) {
        response.data.divergencia = false
      }

      if (!response.data.notaFiscalUrl) {
        response.data.notaFiscalUrl = ''
      }

      if (!response.data.motivo) {
        response.data.motivo = ''
      }

      if (!response.data.numeroNota) {
        response.data.numeroNota = ''
      }

      if (!response.data.numeroContasPagar) {
        response.data.numeroContasPagar = ''
      }

      if (!response.data.empresaMedicaDocumento) {
        response.data.empresaMedicaDocumento = ''
      }

      if (!response.data.comentario) {
        response.data.comentario = ''
      }

      this.context.commit('setPrestadorRecebimento', response.data)
      this.context.commit('setNotaFiscalUnica', response.data.notasFiscais[0])
    }

    return this.prestadorRecebimento
  }

  @Action
  async deleteNotaFiscal() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.prestadorRecebimento.id,
        documentoId: this.idForDeleteNotaFiscal,
      }

      const response = await this.remuneracaoMedica.deleteNotaFiscal(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async provisionarRemuneracao(params: any) {
    const response = await this.remuneracaoMedica.provisionarRemuneracao(params)
    return response
  }

  @Action
  async cancelarProvisionamentoRemuneracao(params: any) {
    const response = await this.remuneracaoMedica.cancelarProvisionamentoRemuneracao(params)
    return response
  }

  @Action
  async criarAgrupamentoPrestadorRecebimento() {
    const params: any = {
      anoMesReferencia: moment(this.anoMesReferenciaListaRepasse, 'YYYY-MM').format('YYYY-MM-DD'),
      fontePagadoraId: this.fontePagadoraId,
      // eslint-disable-next-line
      repassesQueSolicitamNF: this.agrupamentoRpas,
    }

    const response = await this.remuneracaoMedica.criarAgrupamentoPrestadorRecebimento(params)
    if (response.success) {
      this.context.commit('setAgrupamentoRepasse', response.data)
    }
    return response
  }

  @Action
  async enviarNotificacaoDeCobranca(params: any) {
    const response = await this.remuneracaoMedica.sendEmailCobrancaNotaFiscal(params)
    return response
  }

  @Action
  async getDocumentoByPrestadorRecebimentoId() {
    try {
      const { id } = this.agrupamentoRepasse.agrupamento
      const response = await this.remuneracaoMedica.getDocumentoByPrestadorRecebimentoId({ id })
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getItensDoRepasse(id: string) {
    const params: any = {
      pagina: this.pageItems,
      qtdPorPagina: this.qtdPorPagina,
      profissional: this.profissional
    }
    try {
      const response = await this.remuneracaoMedica.getItensDoRepasse(params, id)
      this.context.commit('setItensDoRepasse', response.data)
      this.context.commit('setTotalItensDoRepasse', response.data.totalRegistros)
      this.context.commit('setItemsId', id)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async getRelatorioRecebimento(fontePagadoraIds: string[]) {
    try {
      const atributos: any[] = []
      const fontesPagadoras = fontePagadoraIds || []

      if (this.grupoRepasse) {
        atributos.push({
          nome: 'GrupoRepasseId',
          valor: this.grupoRepasse,
        })
      }

      atributos.push(
        {
          // Escalar com a 1ª fonte: mantém funcionando o relatório cuja query
          // ainda não foi ajustada para `IN @FontePagadoraIds`.
          nome: 'FontePagadoraId',
          valor: fontesPagadoras[0] || '',
        },
        {
          // O `;` final é obrigatório: sem ele o Worker não converte o atributo
          // em lista e o `IN` do SQL quebra.
          nome: 'FontePagadoraIds',
          valor: fontesPagadoras.length ? `${fontesPagadoras.join(';')};` : '',
        },
        {
          nome: 'RelatorioId',
          valor: this.relatorioSelected,
        },
        {
          nome: 'AnoMesReferencia',
          valor: this.anoMesReferenciaExportarRegistros ? `${this.anoMesReferenciaExportarRegistros}-01` : null,
        },
        {
          nome: 'LayoutRelatorio',
          valor: this.layoutRelatorio ? '1' : '0',
        },
        {
          nome: 'Situacao',
          valor: this.situacoesExportarRegistros,
        }
      )

      const params = {
        tipo: 'GeracaoRelatorio',
        atributos,
      }

      const response = await this.remuneracaoMedica.enfileirar(params)
      this.context.commit('setRelatorioEmissaoId', response.data.id)
      return await this.context.dispatch('getRelatorioEmitido')
    } catch (error) {
      return { message: 'Não foi possível exportar o registro.' }
    }
  }


  @Action
  async liberarRepasses() {
    try {
      const params: any = {
        id: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.liberarRepasses(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async liberarRepasseUnico() {
    try {
      const params: any = {
        prestadorRecebimentoIds: [this.idForLoadItensRepasse],
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.liberarRepasseUnico(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async integrarRepasses() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.integrarRepasses(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async recalcularImpostos() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.idPrestadorRecalculo,
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.recalcularImpostos(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async integrarRepasseUnico() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItensRepasse,
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
      }
      const response = await this.remuneracaoMedica.integrarRepasseUnico(params)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async enfileirar() {
    try {
      if (this.recalculoIds.length === 0) return { success: true }

      const atributosArray = [
        {
          nome: 'GeracaoRepasseId',
          valor: this.idForLoadValidacaoEGeracaoRepasse,
        },
      ]

      this.recalculoIds.forEach((id) => {
        atributosArray.push({
          nome: 'MedicoProducaoProcedimentoId',
          valor: id,
        })
      })

      const body = {
        tipo: 'GeracaoRecalcular',
        atributos: atributosArray,
      }

      const response = await this.remuneracaoMedica.enfileirar(body)
      this.context.commit('setDescarteId', response.data.id)

      return await this.context.dispatch('getRecalculoRepasse')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async recalcularItensRegraValorFixo() {
    try {
      if (this.recalculoIdsValorFixo.length === 0) return { success: true }

      return await this.remuneracaoMedica.recalcularItensRegraValorFixo(this.recalculoIdsValorFixo)
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async descartarRepasses() {
    try {
      const body = {
        tipo: 'GeracaoDescarteTodos',
        atributos: [
          {
            nome: 'GeracaoRepasseId',
            valor: this.idForLoadValidacaoEGeracaoRepasse,
          },
        ],
      }

      const response = await this.remuneracaoMedica.descartarRepasses(body)
      this.context.commit('setDescarteId', response.data.id)

      return await this.context.dispatch('getDescarteRepasses')
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async getTipoCargaDownload(tipoArquivo: string) {
    try {
      const params: any = {
        tipoCarga: this.tipoCargaSelected,
        tipoArquivo,
      }
      const response = await this.remuneracaoMedica.getTipoCargaDownload(params)
      if (response.success) {
        this.context.commit('setDownloadTipoCarga', response.data)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível buscar os modelos de carga!', statusCode: 500 }
    }
  }

  @Action
  async desfazerIntegracao() {
    try {
      const params: any = {
        prestadorRecebimentoId: this.idForLoadItensRepasse,
      }
      const response = await this.remuneracaoMedica.desfazerIntegracao(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async desfazerLiberacao() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse,
        prestadorRecebimentoId: this.idForLoadItensRepasse,
      }
      const response = await this.remuneracaoMedica.desfazerLiberacao(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async emitirRelatorio(relatorioId?: string) {
    const maxAttempts = 20
    let attempts = 0
    let params = {}

    params = {
      geracaoRepasseId: [ this.idForLoadValidacaoEGeracaoRepasse ],
    }

    if (relatorioId) {
      params = {
        ...params,
        relatorioId,
      }
    }

    try {
      const response = await this.remuneracaoMedica.emitirRelatoriosEmLote(params)

      if (response.success) {
        this.context.commit('setRelatorioEmitido', response.data.recebimentoId)
      } else {
        console.error('Erro ao emitir relatórios em lote:', response.message)
        return { success: false, message: 'Erro ao emitir relatórios em lote.' }
      }
    } catch (error) {
      return { success: false, message: 'Erro ao chamar a API para emitir relatórios em lote.' }
    }

    while (attempts < maxAttempts) {
      try {
        const response = await this.remuneracaoMedica.getRecebimentoStatus(this.relatorioEmitido)

        if (response.data.recebimento.key === 'Finalizado') {
          return await this.context.dispatch('getUrlArquivo', this.relatorioEmitido)
        }

        // Erro é status final: continuar tentando só deixaria a tela em processamento
        // até esgotar as tentativas, escondendo o motivo da falha.
        if (response.data.recebimento.key === 'Erro') {
          // eslint-disable-next-line no-await-in-loop
          const message = await this.context.dispatch('obterMensagemErroRecebimento', this.relatorioEmitido)
          return { success: false, message }
        }

        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  async getUrlArquivo(url: any) {
    try {
      const response = await this.remuneracaoMedica.getUrlArquivo(url)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível obter a URL do relatório.' }
    }
  }

  // Busca a mensagem do erro registrado no recebimento para exibir o motivo real da falha
  // em vez de uma mensagem genérica. O worker grava a mensagem como JSON.
  @Action
  async obterMensagemErroRecebimento(recebimentoId: any) {
    const mensagemPadrao = 'Não foi possível gerar o relatório.'

    try {
      const params: any = { pagina: 1, qtdPorPagina: 1, recebimentoId }
      const response = await this.remuneracaoMedica.getItemsRecebimentoErros(params)

      if (!response.success || !response.data.itens || response.data.itens.length === 0) return mensagemPadrao

      const { mensagem } = response.data.itens[0]
      if (!mensagem) return mensagemPadrao

      try {
        const conteudo = JSON.parse(mensagem)
        return conteudo.Mensagem || conteudo.message || mensagemPadrao
      } catch (error) {
        return mensagem
      }
    } catch (error) {
      return mensagemPadrao
    }
  }

  @Action
  async emitirRelatorioTabelaPropria(tabelaPrecoId?: string) {
    try {
      const params: any = {
        tabelaPrecoId: tabelaPrecoId,
      }

      const response = await this.remuneracaoMedica.emitirRelatorioTabelaPropria(params)
      this.context.commit('setRelatorioEmitido', response.data)
      return response
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async emitirRelatoriosEmLote() {
    const maxAttempts = 20
    let attempts = 0

    try {
      const geracaoRepassesId = this.emitirRelatorioEmLote.map((e: any) => {
        const c = e.id
        return c
      })

      const params: any = {
        geracaoRepasseId: [...geracaoRepassesId],
      }

      try {
        const response = await this.remuneracaoMedica.emitirRelatoriosEmLote(params)

        if (response.success) {
          this.context.commit('setRelatorioEmitido', response.data.recebimentoId)
        } else {
          console.error('Erro ao emitir relatórios em lote:', response.message)
          return { success: false, message: 'Erro ao emitir relatórios em lote.' }
        }
      } catch (error) {
        return { success: false, message: 'Erro ao chamar a API para emitir relatórios em lote.' }
      }

      while (attempts < maxAttempts) {
        try {

          /* eslint-disable no-await-in-loop */
          const response = await this.remuneracaoMedica.getRecebimentoStatus(this.relatorioEmitido)

          if (response.data.recebimento.key === 'Finalizado') {
            return await this.context.dispatch('getUrlArquivo', this.relatorioEmitido)
          }

          // Erro é status final: continuar tentando só deixaria a tela em processamento
          // até esgotar as tentativas, escondendo o motivo da falha.
          if (response.data.recebimento.key === 'Erro') {
            const message = await this.context.dispatch('obterMensagemErroRecebimento', this.relatorioEmitido)
            return { success: false, message }
          }
          // NÃO REMOVER - PARA DEBUG DO HOSPITAL
          console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

          /* eslint-disable no-await-in-loop */
          await this.context.dispatch('delay', 15000)
        } catch (error) {
          console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
        }

        attempts += 1
      }

      console.error('Excedido o número máximo de tentativas. Ação não concluída.')
      return { success: false }

    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async getRelatorioEmitido() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = { relatorioEmissaoId: this.relatorioEmissaoId }
        const statusResponse = await this.remuneracaoMedica.getRelatorioStatus(params)

        if (statusResponse.data.emProcessamento === false) {
          const response = await this.remuneracaoMedica.getRelatorioEmitido(params)

          if (response.data.ArquivoUrl) {
            const arquivoUrl = response.data.ArquivoUrl
            const nomeArquivo = response.data.NomeArquivo

            this.context.commit('setRelatorioEmitido', {
              url: arquivoUrl,
              nome: nomeArquivo
            })

            return {
              success: true,
              data: {
                file: arquivoUrl,
                fileName: nomeArquivo
              }
            }
          }

          return { success: false, message: 'Arquivo não encontrado.' }
        }

        await this.context.dispatch('delay', 15000)
      } catch (e) {
        console.error(e)
      }

      attempts++
    }

    return {
      success: false,
      message: 'Tempo limite excedido.'
    }
  }

  @Action
  async getEmissaoRelatorio() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          relatorioEmissaoId: this.relatorioEmissaoId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getEmissaoRelatorio(params)

        if (response.data.processoFinalizado && response.data.arquivoUrl === '') {
          // NÃO REMOVER - PARA DEBUG DO HOSPITAL
          console.log('O processo está finalizado, mas não há URL de arquivo. Encerrando a função.')
          return { success: false }
        }

        if (response.data.processoFinalizado && response.data.arquivoUrl) {
          this.context.commit('setRelatorioEmitido', response.data.arquivoUrl)
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  async getRecalculoRepasse() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          id: this.descarteId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getRecalculoRepasse(params)

        if (response.data.emProcessamento === false) {
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  async getDescarteRepasses() {
    const maxAttempts = 20
    let attempts = 0

    while (attempts < maxAttempts) {
      try {
        const params = {
          id: this.descarteId,
        }

        /* eslint-disable no-await-in-loop */
        const response = await this.remuneracaoMedica.getDescarteRepasses(params)

        if (response.data.emProcessamento === false) {
          return response
        }
        // NÃO REMOVER - PARA DEBUG DO HOSPITAL
        console.log(`O processo ainda está em andamento. Tentativa ${attempts + 1}`)

        /* eslint-disable no-await-in-loop */
        await this.context.dispatch('delay', 15000)
      } catch (error) {
        console.error(`Tentativa ${attempts + 1} falhou: ${error}`)
      }

      attempts += 1
    }

    console.error('Excedido o número máximo de tentativas. Ação não concluída.')
    return { success: false }
  }

  @Action
  delay(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  // Recebe os filtros da modal por parâmetro: a modal mantém estado próprio para não
  // colidir com os filtros da listagem, que continuam vivendo neste store.
  @Action
  async filtroDownloadNotaFiscal(filtros: any) {
    try {
      const params: any = {
        anoMesReferencia: filtros.anoMesReferencia || null,
        fontePagadoraId: filtros.fontePagadoraId || null,
        grupoRepasseId: filtros.grupoRepasseId || null,
        createdOnNFDe: filtros.createdOnNFDe || null,
        createdOnNFAte: filtros.createdOnNFAte || null,
        status: filtros.status || null,
      }
      const response = await this.remuneracaoMedica.filtroDownloadNotaFiscal(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async validarRepasses(params: any) {
    try {
      const response = await this.remuneracaoMedica.validarRepasses(params)
      return response.success
        ? { success: true }
        : { success: false, message: 'Não foi possível realizar esta ação.' }
    } catch (error) {
      return { success: false, message: 'Não foi possível realizar esta ação.', statusCode: 500 }
    }
  }

  @Action
  async notificarManualmenteRecebimento(params: any) {
    const response = await this.remuneracaoMedica.notificarManualmenteRecebimento(params)
    return response
  }

  @Action
  async atualizarRecebimetno(notaFiscal: PrestadorRecebimento) {
    const response = await this.remuneracaoMedica.atualizarNotaFiscal(notaFiscal)
    return response
  }

  @Action
  async deletarDocumentoPrestadorRecebimento(params: any) {
    const response = await this.remuneracaoMedica.deletarDocumentoPrestadorRecebimento(params)
    return response
  }

  @Action
  async deletarDocumento(params: any) {
    const response = await this.remuneracaoMedica.deletarDocumento(params)
    return response
  }

  @Mutation
  setNaoCarregarPrestadorComCalculo(value: boolean) {
    this.naoCarregarPrestadorComCalculo = value
  }

  @Action
  async importacaoArquivoRecebimento(form: any) {
    const tipoCarga = this.tipoCargaSelected
    const response = await this.remuneracaoMedica.importacaoArquivoRecebimento(form, tipoCarga, this.anoMesReferencia, this.anoMesCompetencia, this.transacaoUnica, this.naoCarregarPrestadorComCalculo)
    return response
  }

  @Action
  async uploadNotaFiscal(params: any) {
    const response = await this.remuneracaoMedica.uploadNotaFiscal(params)
    return response
  }

  @Action
  async uploadNotaFiscalUnica({ params, typeFile }: { params: any, typeFile: string }) {
    try {
      const response = await this.remuneracaoMedica.uploadNotaFiscal(params)

      if (response.success && typeFile === 'pdf') {
        this.context.commit('setDocumentoId', response.data)
      }
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async uploadDocumentosAdicionais(params: any) {
    try {
      const response = await this.remuneracaoMedica.uploadDocumentosAdicionais(params)
      return response
    } catch (error) {
      return { success: false }
    }
  }

  @Action
  async download(params: any) {
    const response = await this.remuneracaoMedica.download(params)
    return response
  }

  @Action
  async getLogs() {
    const response = await this.remuneracaoMedica.getLogs()
    if (response.success) {
      this.context.commit('setCargaLogs', response.data)
    }
    return response
  }

  @Action
  async getPrestadorRecebimentoLogs(params: { geracaoRepasseId: string; prestadorRecebimentoId: string }) {
    try {
      const response = await this.remuneracaoMedica.getPrestadorRecebimentoLogs(params)
      if (response.success) {
        this.context.commit('setLogsPrestadorRecebimento', response.data.itens)
        this.context.commit('setModal', { name: 'logsPrestadorRecebimento', value: true })
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async sendEmailCobrancaNotaFiscal(params: any) {
    const response = await this.remuneracaoMedica.sendEmailCobrancaNotaFiscal(params)
    return response
  }

  @Action
  async getLoteNotificacao(id: string) {
    const response = await this.remuneracaoMedica.getLoteNotificacao(id)
    return response
  }

  @Action
  async getLotesNotificacao(params: LotesNotificacaoParams) {
    const response = await this.remuneracaoMedica.getLotesNotificacao(params)
    return response
  }

  @Action
  async getLoteDetalhes(payload: { id: string, params: LoteDetalhesParams }) {
    const response = await this.remuneracaoMedica.getLoteDetalhes(payload.id, payload.params)
    return response
  }

  @Action
  async getGrupoRepasseAll() {
    const response = await this.remuneracaoMedica.getGrupoRepasseAll()
    if (response.success) {
      this.context.commit('setGrupoRepasseItensAll', response.data)
    }

    return response
  }

  @Action
  async getDocumentoPrestadorRecebimento(id: string) {
    const response = await this.remuneracaoMedica.getDocumentoPrestadorRecebimento(id)
  }

  @Action
  async atualizarAgrupamento() {
    const params: any = { ...this.agrupamentoRepasse.agrupamento }
    const response = await this.remuneracaoMedica.atualizarAgrupamento(params)
    return response
  }

  @Action
  async deletarNotaFiscal() {
    try {
      const response = await this.remuneracaoMedica.deletarNotaFiscal(this.deleteNotaFiscalId)
      return response
    } catch (error) {
      return { message: error }
    }
  }

  @Action
  async deletarDocumentoAdicional(params: any) {
    const response = await this.remuneracaoMedica.deletarDocumentoAdicional(params)
    return response
  }

  @Action
  async getTemplateNotificacaoConfig(param: any) {
    const response = await this.remuneracaoMedica.getTemplateNotificacaoConfig(param)
    if (response.success) {
      this.context.commit('setTemplateNotificarConfig', response.data)
    }
    return response
  }

  @Action
  async recalcular() {
    try {
      const params: any = {
        salvarCalculoParaValidacao: false,
        recalcularERecriarRecebimentos: true,
        mesReferencia: `${this.anoMesReferenciaRecalcularValores}-01`,
        dataRecebimento: this.dataRecebimentoRecalcularValores,
        prazo: this.prazoRecalcularValores,
      }
      // O método não existe ainda... Corrigido problema de lint por hora usando tipagem any
      const response = await (Apis.Legacy.Producao as any).recalcular(params)
      return response
    } catch (error) {
      return { message: 'Não foi possível calcular os repasses.' }
    }
  }

  @Action
  async getPessoaPrestadorAll(params: any = {}) {
    const response = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
    if (response.success) {
      const prestadores = response.data.prestadores
        ? response.data.prestadores
        : []
      this.context.commit('setPrestadoresLista', prestadores)
    }
    return response
  }

  @Action
  async getImpostoPrestador(params: any = {}) {
    const response = await this.remuneracaoMedica.getImpostoPrestador(params)
    if (response.success) {
      const prestadores = response.data.itens
        ? response.data.itens
        : []
      this.context.commit('setImpostoPrestadorList', prestadores)
    }
    return response
  }

  @Action
  async alterarPrestador(params: any) {
    const response = await this.remuneracaoMedica.alterarPrestador(params)
    return response
  }

  @Action
  async deletarRepasse() {
    const response = await this.remuneracaoMedica.deletarRepasse(this.solicitacaoId)
    return response
  }

  /**
   * PAGINAÇÃO TABELA DE REFERÊNCIA
   */

  public pagination: any = {
    descending: false,
    page: 1,
    rowsPerPage: 50,
    sortBy: null,
    totalItems: null,
    rowsPerPageItems: [10, 25, 50, 100, -1],
  }

  @Mutation
  setPagination(value: any) {
    this.pagination = value
  }

  /**
   * Items de senioridade
   */
  private itemsSenioridadeDefault: ItemSenioridade[] = []
  public itemsSenioridade: ItemSenioridade[] = [...this.itemsSenioridadeDefault]
  private itemSenioridadeDefault: ItemSenioridade = {
    id: '',
    nome: '',
    codigoPontuacao: '',
    percentual: '',
    tabelaPrecoId: '',
  }

  public originalItemSenioridade: ItemSenioridade = { ...this.itemSenioridadeDefault }

  public itemSenioridade: ItemSenioridade = { ...this.itemSenioridadeDefault }
  public itemsSenioridadePagina: number = 1
  public itemsSenioridadeQtdPorPagina: number = 50
  public itemsSenioridadeTotal: number = 0

  @Mutation
  setItemsSenioridade(value: ItemSenioridade[]) {
    this.itemsSenioridade = value
  }

  @Mutation
  clearItemsSenioridade() {
    this.itemsSenioridade = []
  }

  @Mutation
  setItemSenioridade(value: ItemSenioridade) {
    this.itemSenioridade = value
  }

  @Mutation
  clearItemSenioridade() {
    this.itemSenioridade = { ...this.itemSenioridadeDefault }
  }

  @Mutation
  setOriginalItemSenioridade(value: ItemSenioridade) {
    this.originalItemSenioridade = value
  }

  @Mutation
  clearOriginalItemSenioridade() {
    this.originalItemSenioridade = { ...this.itemSenioridadeDefault }
  }

  @Mutation
  setItemsSenioridadePagina(value: number) {
    this.itemsSenioridadePagina = value
  }

  @Mutation
  setItemsSenioridadeTotal(value: number) {
    this.itemsSenioridadeTotal = value
  }

  @Mutation
  removeItemSenioridade(id: string) {
    const index = this.itemsSenioridade.findIndex((e: any) => e.id === id)
    this.itemsSenioridade.splice(index, 1)
  }

  @Action
  async getAllItemsSenioridade() {
    try {
      const params: any = {
        pagina: this.itemsSenioridadePagina,
        qtdPorPagina: this.qtdPorPagina,
        codigoPontuacaoOuNome: this.filtroCodigoPontuacaoOuNome
      }

      const request = await this.remuneracaoMedica.getAllItemsSenioridade(params)

      if (request.success) {
        this.context.commit('setItemsSenioridade', request.data.itens as ItemSenioridade[])
        this.context.commit('setItemsSenioridadePagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsSenioridadeTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsSenioridade', [])
      return { success: false, message: error }
    }
  }

  @Action
  async createItemsSenioridade() {
    try {
      const { nome, codigoPontuacao, percentual, tabelaPrecoId } = this.itemSenioridade
      /** A API tipa percentual como decimal e tabelaPrecoId como decimal? — string vazia não desserializa e derruba a requisição. */
      const params: any = {
        nome,
        codigoPontuacao,
        percentual: Number(percentual) || 0,
        tabelaPrecoId: tabelaPrecoId ? Number(tabelaPrecoId) : null,
      }
      const request = await this.remuneracaoMedica.createItemsSenioridade(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updateItemsSenioridade() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemSenioridade, this.originalItemSenioridade)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, nome, codigoPontuacao, percentual, tabelaPrecoId } = this.itemSenioridade
      /** A API tipa percentual como decimal e tabelaPrecoId como decimal? — string vazia não desserializa e derruba a requisição. */
      const params: any = {
        id,
        nome,
        codigoPontuacao,
        percentual: Number(percentual) || 0,
        tabelaPrecoId: tabelaPrecoId ? Number(tabelaPrecoId) : null,
      }
      const request = await this.remuneracaoMedica.updateItemsSenioridade(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deleteItemSenioridade(id: string) {
    try {
      const request = await this.remuneracaoMedica.deleteItemSenioridade(id)
      if (request.success) this.context.commit('removeItemSenioridade', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  /**
   * Items da tabela preço procedimento
   */
  public itemTabelaReferenciaId: string | number = ''
  private itemsTabelaPrecoProcedimentoDefault: ItemTabelaPrecoProcedimento[] = []
  public itemsTabelaPrecoProcedimento: ItemTabelaPrecoProcedimento[] = [...this.itemsTabelaPrecoProcedimentoDefault]
  private itemTabelaPrecoProcedimentoDefault: ItemTabelaPrecoProcedimento = {
    id: '',
    codigoUnico: '',
    descricao: '',
    valorProcedimento: 0,
    fatorViaUnica: 0,
    fatorViaMesma: 0,
    fatorViaSeparada: 0,
    fatorViaBilateral: 0,
    valorDiurno: 0,
    valorDomingo: 0,
    valorFeriado: 0,
    valorMadrugada: 0,
    valorNoturno: 0,
    valorPediatria: 0,
    valorSabado: 0,
    valorUrgencia: 0,
  }

  public originalItemTabelaPrecoProcedimento: ItemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }

  public itemTabelaPrecoProcedimento: ItemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }
  public itemsTabelaPrecoProcedimentoPagina: number = 1
  public itemsTabelaPrecoDetailsPagina: number = 1
  public itemsTabelaPrecoProcedimentoQtdPorPagina: number = 50
  public itemsTabelaPrecoProcedimentoTotal: number = 0
  public itemsTabelaPrecoDetailsTotal: number = 0
  public itemsMonitorIntegracao: any[] = []
  public totalItemsMonitorIntegracao: number = 0
  public itemTabelaPreco: any = {}

  @Mutation
  setItemTabelaReferenciaId(value: string | number) {
    this.itemTabelaReferenciaId = value
  }

  @Mutation
  setItemTabelaPreco(value: any) {
    this.itemTabelaPreco = value
  }

  @Mutation
  clearItemTabelaReferenciaId() {
    this.itemTabelaReferenciaId = ''
  }

  @Mutation
  setItemsTabelaPrecoProcedimento(value: ItemTabelaPrecoProcedimento[]) {
    this.itemsTabelaPrecoProcedimento = value
  }

  @Mutation
  removeItemFromTabelaPrecoProcedimento(id: string | number) {
    const index = this.itemsTabelaPrecoProcedimento.findIndex((e: any) => e.id === id)
    this.itemsTabelaPrecoProcedimento.splice(index, 1)
  }

  @Mutation
  clearItemsTabelaPrecoProcedimento() {
    this.itemsTabelaPrecoProcedimento = []
  }

  @Mutation
  setItemTabelaPrecoProcedimento(value: ItemTabelaPrecoProcedimento) {
    this.itemTabelaPrecoProcedimento = value
  }

  @Mutation
  clearItemTabelaPrecoProcedimento() {
    this.itemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }
  }

  @Mutation
  setOriginalItemTabelaPrecoProcedimento(value: ItemTabelaPrecoProcedimento) {
    this.originalItemTabelaPrecoProcedimento = value
  }

  @Mutation
  clearOriginalItemTabelaPrecoProcedimento() {
    this.originalItemTabelaPrecoProcedimento = { ...this.itemTabelaPrecoProcedimentoDefault }
  }

  @Mutation
  setItemsTabelaPrecoProcedimentoPagina(value: number) {
    this.itemsTabelaPrecoProcedimentoPagina = value
  }

  @Mutation
  setItemsTabelaPrecoDetailsPagina(value: number) {
    this.itemsTabelaPrecoDetailsPagina = value
  }

  @Mutation
  setItemsTabelaPrecoDetailsTotal(value: number) {
    this.itemsTabelaPrecoDetailsTotal = value
  }

  @Mutation
  setItemsTabelaPrecoProcedimentoTotal(value: number) {
    this.itemsTabelaPrecoProcedimentoTotal = value
  }

  @Action
  async getItensByTabelaDeReferenciaId() {
    try {
      const params: any = {
        tabelaReferenciaId: this.itemTabelaReferenciaId,
        codigo: this.searchCodigoDebounce,
        descricao: this.searchDescricaoDebounce,
        pagina: this.itemsTabelaPrecoProcedimentoPagina,
        qtdPorPagina: this.itemsTabelaPrecoProcedimentoQtdPorPagina,
      }

      const request = await this.remuneracaoMedica.getItensByTabelaDeReferenciaId(params)

      if (request.success) {
        this.context.commit('setItemsTabelaPrecoProcedimento', request.data.itens as ItemTabelaPrecoProcedimento[])
        this.context.commit('setItemsTabelaPrecoProcedimentoPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsTabelaPrecoProcedimentoTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      this.context.commit('setItemsTabelaPrecoProcedimento', [])
      return { success: false, message: error }
    }
  }

  @Action
  async createItemsTabelaPrecoProcedimento() {
    try {
      const params: any = { tabelaPrecoId: this.itemTabelaReferenciaId, ...this.itemTabelaPrecoProcedimento }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
        if (key === 'id') delete params[key]
      })

      const request = await this.remuneracaoMedica.createItensByTabelaDeReferenciaId(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updateItemByTabelaDeReferenciaId() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemTabelaPrecoProcedimento, this.originalItemTabelaPrecoProcedimento)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, codigoUnico, descricao, valorProcedimento, fatorViaUnica, fatorViaMesma, fatorViaSeparada, fatorViaBilateral, valorDiurno, valorDomingo, valorFeriado, valorMadrugada, valorNoturno, valorPediatria, valorSabado, valorUrgencia } = this.itemTabelaPrecoProcedimento

      const params: any = {
        tabelaPrecoId: this.itemTabelaReferenciaId,
        tabelaPrecoProcedimentoId: id,
        id,
        codigoUnico,
        descricao,
        valorProcedimento,
        fatorViaUnica,
        fatorViaMesma,
        fatorViaSeparada,
        fatorViaBilateral,
        valorDiurno,
        valorDomingo,
        valorFeriado,
        valorMadrugada,
        valorNoturno,
        valorPediatria,
        valorSabado,
        valorUrgencia,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.updateItemByTabelaDeReferenciaId(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deleteItemByTabelaDeReferenciaId(id: string | number) {
    try {
      const request = await this.remuneracaoMedica.deleteItemByTabelaDeReferenciaId({
        tabelaPrecoId: this.itemTabelaReferenciaId,
        tabelaPrecoProcedimentoId: id,
      })
      if (request.success) this.context.commit('removeItemFromTabelaPrecoProcedimento', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  /**
   * Itens da tabela taxa de aluguel
   */
  @Action
  async getPrestadorTaxaAluguel(params: any = {}) {
    const response = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
    if (response.success) {
      const prestadores = response.data.prestadores
        ? response.data.prestadores
        : []
      prestadores.unshift({ userId: '', nome: TAXA_PADRAO, documento: '' })
      this.context.commit('setPrestadoresLista', prestadores)
      this.context.commit('setPrestadoresListaImposto', prestadores)
    }
    return response
  }

  private profissionalIdDefault: string = ''
  public profissionalId: string = this.profissionalIdDefault
  private itemsPontuacaoProfissionalDefault: ItemPontuacaoProfissional[] = []
  public itemsPontuacaoProfissional: ItemPontuacaoProfissional[] = [...this.itemsPontuacaoProfissionalDefault]
  private itemPontuacaoProfissionalDefault: ItemPontuacaoProfissional = {
    id: '',
    pontuacaoId: '',
    profissionalId: '',
    equipeProfissionalId: '',
    hospitalId: '',
  }

  public itemPontuacaoProfissional: ItemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }
  public originalItemPontuacaoProfissional: ItemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }

  public itemsTabelaPontuacaoProfissionalPagina: number = 1
  public paginaVinculosRelatorios: number = 1
  public itemsTabelaPontuacaoProfissionalQtdPorPagina: number = 10
  public itemsTabelaPontuacaoProfissionalTotal: number = 0
  public totalItemsVinculos: number = 0
  public totalItemsImpostoPrestador: number = 0

  @Mutation
  setItemsTabelaPontuacaoProfissionalPagina(value: number) {
    this.itemsTabelaPontuacaoProfissionalPagina = value
  }

  @Mutation
  setPaginaVinculosRelatorios(value: number) {
    this.paginaVinculosRelatorios = value
  }

  @Mutation
  setItemsTabelaPontuacaoProfissionalTotal(value: number) {
    this.itemsTabelaPontuacaoProfissionalTotal = value
  }

  @Mutation
  setTotalItemsVinculos(value: number) {
    this.totalItemsVinculos = value
  }

  @Mutation
  setTotalItemsImpostoPrestador(value: number) {
    this.totalItemsImpostoPrestador = value
  }

  @Mutation
  setVinculosRelatorios(value: any[]) {
    this.vinculosRelatorios = value
  }

  @Mutation
  setImpostoPrestadores(value: any[]) {
    this.impostoPrestadores = value
  }

  @Mutation
  setRelatoriosAll(value: any[]) {
    this.relatoriosAll = value
  }

  @Mutation
  clearItemVinculoRelatorio() {
    this.relatorioId = ''
    this.pessoaId = ''
  }

  @Mutation
  clearItemImpostoPrestador() {
    this.alicota = ''
    this.impostoPrestadorId = ''
    this.impostoId = ''
    this.valorMinimoTributo = ''
    this.pessoaId = ''
  }

  @Mutation
  setItemPontuacaoProfissional(value: ItemPontuacaoProfissional) {
    this.itemPontuacaoProfissional = value
  }

  @Mutation
  clearItemPontuacaoProfissional() {
    this.itemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }
  }

  @Mutation
  setIdForEditItemImpostoPrestador(value: string) {
    this.impostoPrestadorId = value
  }

  @Mutation
  setEditItemImpostoPrestador(item: any) {
    const pessoaId = (item && (item.prestadorId || item.userId)) || ''
    const impostoId = (item && item.impostoId) || ''

    const alicotaVal = item && item.alicota != null ? item.alicota : '0'
    const valorMinimoVal = item && item.valorMinimoTributo != null ? item.valorMinimoTributo : '0'

    this.pessoaId = pessoaId
    this.impostoId = impostoId
    this.alicota = String(alicotaVal)
    this.valorMinimoTributo = String(valorMinimoVal)
  }

  @Mutation
  setProfissionalId(value: string) {
    this.profissionalId = value
  }

  @Mutation
  clearProfissionalId() {
    this.profissionalId = this.profissionalIdDefault
  }

  @Mutation
  setItemsPontuacaoProfissional(value: ItemPontuacaoProfissional[]) {
    this.itemsPontuacaoProfissional = value
  }

  @Mutation
  clearItemsPontuacaoProfissional() {
    this.itemsPontuacaoProfissional = [...this.itemsPontuacaoProfissionalDefault]
  }

  @Mutation
  setOriginalItemPontuacaoProfissional(value: ItemPontuacaoProfissional) {
    this.originalItemPontuacaoProfissional = value
  }

  @Mutation
  clearOriginalItemPontuacaoProfissional() {
    this.originalItemPontuacaoProfissional = { ...this.itemPontuacaoProfissionalDefault }
  }

  @Mutation
  removeItemFromPontuacaoProfissional(id: string | number) {
    const index = this.itemsPontuacaoProfissional.findIndex((e: any) => e.id === id)
    this.itemsPontuacaoProfissional.splice(index, 1)
  }

  @Action
  async getPontuacaoProfissionalAll() {
    try {
      const request = await this.remuneracaoMedica.getPontuacaoProfissionalAll({
        profissionalId: this.profissionalId,
        filtroValorPontuacao: this.filtroValorPontuacao,
        equipeProfissionalId: this.filtroEquipeProfissional,
        hospitalId: this.filtroHospitalId,
        pagina: this.itemsTabelaPontuacaoProfissionalPagina,
        qtdPorPagina: this.itemsTabelaPontuacaoProfissionalQtdPorPagina,
      })

      if (request.success) {
        this.context.commit('setItemsPontuacaoProfissional', request.data.itens as ItemPontuacaoProfissional[])
        this.context.commit('setItemsTabelaPontuacaoProfissionalPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsTabelaPontuacaoProfissionalTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async criarVinculoRelatorio() {
    try {
      const params: any = {
        relatorioId: this.relatorioId,
        pessoaId: this.pessoaId,
      }
      const request = await this.remuneracaoMedica.criarVinculoRelatorio(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async criarImpostoPrestador() {
    try {
      const params: any = {
        prestadorId: this.pessoaId,
        impostoId: this.impostoId,
        alicota: parseFloat(this.alicota),
        valorMinimoTributo: parseFloat(this.valorMinimoTributo),
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.criarImpostoPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async editarImpostoPrestador() {
    try {
      const params: any = {
        id: this.impostoPrestadorId,
        prestadorId: this.pessoaId,
        impostoId: this.impostoId,
        alicota: parseFloat(this.alicota),
        valorMinimoTributo: parseFloat(this.valorMinimoTributo),
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.criarImpostoPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  public relatorioIdFilter: string = ''
  public pessoaIdFilter: string = ''
  public areaFilter: string = ''

  @Mutation
  setRelatorioIdFilter(value: string) {
    this.relatorioIdFilter = value
  }

  @Mutation
  setPessoaIdFilter(value: string) {
    this.pessoaIdFilter = value
  }

  @Mutation
  setAreaFilter(value: string) {
    this.areaFilter = value
  }

  @Action
  async getVinculosRelatorios() {
    try {
      const params: any = {
        relatorioId: this.relatorioIdFilter,
        pessoaId: this.pessoaIdFilter,
        area: this.areaFilter,
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      const request = await this.remuneracaoMedica.getVinculosRelatorios(params)


      if (request.success) {
        this.context.commit('setVinculosRelatorios', request.data.itens)
        this.context.commit('setTotalItemsVinculos', request.data.totalRegistros)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getImpostoPrestadores() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
        prestadorId: this.prestadorIdFilter,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.getImpostoPrestadores(params)


      if (request.success) {
        this.context.commit('setImpostoPrestadores', request.data.itens)
        this.context.commit('setTotalItemsImpostoPrestador', request.data.totalRegistros)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getRelatoriosAll() {
    try {
      const request = await this.remuneracaoMedica.getRelatoriosAll()

      if (request.success) {
        this.context.commit('setRelatoriosAll', request.data.itens)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async updateRelatorio(params: any) {
    try {
      const request = await this.remuneracaoMedica.updateRelatorio(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async updateRelatorioArquivoLayout(params: { relatorioId: string, form: FormData }) {
    try {
      const request = await this.remuneracaoMedica.updateRelatorioArquivoLayout(params.relatorioId, params.form)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async createPontuacaoProfissional() {
    try {
      const params: any = { ...this.itemPontuacaoProfissional }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.createPontuacaoProfissional(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updatePontuacaoProfissional() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemPontuacaoProfissional, this.originalItemPontuacaoProfissional)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, profissionalId, pontuacaoId, hospitalId, equipeProfissionalId } = this.itemPontuacaoProfissional

      const params: any = {
        id,
        profissionalId,
        pontuacaoId,
        hospitalId,
        equipeProfissionalId,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.updatePontuacaoProfissional(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deletePontuacaoProfissional(id: string) {
    try {
      const request = await this.remuneracaoMedica.deletePontuacaoProfissional(id)
      if (request.success) this.context.commit('removeItemFromPontuacaoProfissional', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async deleteVinculoRelatorio(id: string) {
    try {
      const param: any = {
        relatorioPerfilId: id,
      }
      const request = await this.remuneracaoMedica.deleteVinculoRelatorio(param)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async deleteImpostoPrestador(id: string) {
    try {
      const param: any = {
        id,
      }
      const request = await this.remuneracaoMedica.deleteImpostoPrestador(param)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  /**
   * Itens da tabela de taxa de aluguel
   */
  private itemsTaxaAluguelDefault: ItemTaxaAluguel[] = []
  public itemsTaxaAluguel: ItemTaxaAluguel[] = [...this.itemsTaxaAluguelDefault]
  private itemTaxaAluguelDefault: ItemTaxaAluguel = {
    id: '',
    prestadorId: '',
    fontePagadoraId: '',
    tipo: TaxaAluguelTipoEnum.Fixo,
    valor: 0,
  }

  public itemTaxaAluguel: ItemTaxaAluguel = { ...this.itemTaxaAluguelDefault }
  public originalItemTaxaAluguel: ItemTaxaAluguel = { ...this.itemTaxaAluguelDefault }

  private taxaAluguelPrestadorDefault: PrestadorTaxaAluguel = {
    userId: '',
    nome: '',
    documento: '',
  }

  public taxaAluguelPrestador: PrestadorTaxaAluguel = { ...this.taxaAluguelPrestadorDefault }
  public itemsTabelaTaxaAluguelPagina: number = 1
  public itemsTabelaTaxaAluguelQtdPorPagina: number = 50
  public itemsTabelaTaxaAluguelTotal: number = 0
  public parametrosAplicacaoTaxaAluguelPagina: number = 1
  public parametrosAplicacaoTaxaAluguelQtdPorPagina: number = 10
  public parametrosAplicacaoTaxaAluguelTotal: number = 0
  public parametrosAplicacaoTaxaAluguelFontePagadoraId: string = ''
  public parametrosAplicacaoTaxaAluguelPrestadorId: string = ''
  private itemParametroAplicacaoTaxaAluguelDefault = {
    id: '',
    fontePagadoraId: '',
    prestadorId: '',
    centroDeCustoId: '',
  }

  public itemParametroAplicacaoTaxaAluguel = { ...this.itemParametroAplicacaoTaxaAluguelDefault }
  public originalItemParametroAplicacaoTaxaAluguel = { ...this.itemParametroAplicacaoTaxaAluguelDefault }

  @Mutation
  setTaxaAluguelPrestador(value: PrestadorTaxaAluguel) {
    this.taxaAluguelPrestador = value
  }

  @Mutation
  clearTaxaAluguelPrestador() {
    this.taxaAluguelPrestador = { ...this.taxaAluguelPrestadorDefault }
  }

  @Mutation
  setItemsTabelaTaxaAluguelPagina(value: number) {
    this.itemsTabelaTaxaAluguelPagina = value
  }

  @Mutation
  setItemsTabelaTaxaAluguelTotal(value: number) {
    this.itemsTabelaTaxaAluguelTotal = value
  }

  @Mutation
  setParametrosAplicacaoTaxaAluguelPagina(value: number) {
    this.parametrosAplicacaoTaxaAluguelPagina = value
  }

  @Mutation
  setParametrosAplicacaoTaxaAluguelQtdPorPagina(value: number) {
    this.parametrosAplicacaoTaxaAluguelQtdPorPagina = value
  }

  @Mutation
  setParametrosAplicacaoTaxaAluguelTotal(value: number) {
    this.parametrosAplicacaoTaxaAluguelTotal = value
  }

  @Mutation
  setParametrosAplicacaoTaxaAluguelFontePagadoraId(value: string) {
    this.parametrosAplicacaoTaxaAluguelFontePagadoraId = value
  }

  @Mutation
  setParametrosAplicacaoTaxaAluguelPrestadorId(value: string) {
    this.parametrosAplicacaoTaxaAluguelPrestadorId = value
  }

  @Mutation
  setItemTaxaAluguel(value: ItemTaxaAluguel) {
    this.itemTaxaAluguel = value
  }

  @Mutation
  clearItemTaxaAluguel() {
    this.itemTaxaAluguel = { ...this.itemTaxaAluguelDefault }
  }

  @Mutation
  setItemsTaxaAluguel(value: ItemTaxaAluguel[]) {
    const mappedValue = value.map((item: ItemTaxaAluguel) => {
      const i = item
      if (['', null, undefined].includes(i.nomePrestador) || ['', null, undefined].includes(i.prestadorId)) {
        i.nomePrestador = TAXA_PADRAO
      }
      return i
    })
    this.itemsTaxaAluguel = mappedValue
  }

  @Mutation
  clearItemsTaxaAluguel() {
    this.itemsTaxaAluguel = [...this.itemsTaxaAluguelDefault]
  }

  @Mutation
  setItemParametroAplicacaoTaxaAluguel(value: any) {
    this.itemParametroAplicacaoTaxaAluguel = {
      ...this.itemParametroAplicacaoTaxaAluguelDefault,
      ...value,
    }
  }

  @Mutation
  clearItemParametroAplicacaoTaxaAluguel() {
    this.itemParametroAplicacaoTaxaAluguel = { ...this.itemParametroAplicacaoTaxaAluguelDefault }
  }

  @Mutation
  setOriginalItemParametroAplicacaoTaxaAluguel(value: any) {
    this.originalItemParametroAplicacaoTaxaAluguel = {
      ...this.itemParametroAplicacaoTaxaAluguelDefault,
      ...value,
    }
  }

  @Mutation
  clearOriginalItemParametroAplicacaoTaxaAluguel() {
    this.originalItemParametroAplicacaoTaxaAluguel = { ...this.itemParametroAplicacaoTaxaAluguelDefault }
  }

  @Mutation
  setOriginalItemTaxaAluguel(value: ItemTaxaAluguel) {
    this.originalItemTaxaAluguel = value
  }

  @Mutation
  clearOriginalItemTaxaAluguel() {
    this.originalItemTaxaAluguel = { ...this.itemTaxaAluguelDefault }
  }

  @Mutation
  removeItemFromTaxaAluguel(id: string | number) {
    const index = this.itemsTaxaAluguel.findIndex((e: any) => e.id === id)
    this.itemsTaxaAluguel.splice(index, 1)
  }

  @Action
  async getTaxaAluguelAll() {
    try {
      const request = await this.remuneracaoMedica.getTaxaAluguelAll({
        prestadorId: this.taxaAluguelPrestador.userId,
        taxaPadrao: this.taxaAluguelPrestador.taxaPadrao,
        pagina: this.itemsTabelaTaxaAluguelPagina,
        qtdPorPagina: this.itemsTabelaTaxaAluguelQtdPorPagina,
      })

      if (request.success) {
        this.context.commit('setItemsTaxaAluguel', request.data.itens as ItemTaxaAluguel[])
        this.context.commit('setItemsTabelaTaxaAluguelPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsTabelaTaxaAluguelTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async createTaxaAluguel() {
    try {
      const params: any = { ...this.itemTaxaAluguel }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.createTaxaAluguel(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o registro.' }
    }
  }

  @Action
  async updateTaxaAluguel() {
    try {
      /** Evita requisição desnecessária à API... */
      if (isEqual(this.itemTaxaAluguel, this.originalItemTaxaAluguel)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }

      const { id, prestadorId, fontePagadoraId, tipo, valor } = this.itemTaxaAluguel

      const params: any = {
        id,
        prestadorId,
        fontePagadoraId,
        tipo,
        valor,
      }

      /** Limpa todos os valores nulos e vazios */
      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', undefined, null].includes(value)) delete params[key]
      })

      const request = await this.remuneracaoMedica.updateTaxaAluguel(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o registro.' }
    }
  }

  @Action
  async deleteTaxaAluguel(id: string) {
    try {
      const request = await this.remuneracaoMedica.deleteTaxaAluguel(id)
      if (request.success) this.context.commit('removeItemFromTaxaAluguel', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o registro.' }
    }
  }

  @Action
  async getPrestadorTaxaAluguelAll(params: any = {}) {
    try {
      const response = await this.remuneracaoMedica.getPessoaPrestadorAll(params)
      if (response.success) {
        const prestadores = response.data.prestadores ? response.data.prestadores : []
        prestadores.unshift({ userId: '', nome: 'TAXA PADRÃO', documento: '', taxaPadrao: true })
        this.context.commit('setPrestadoresLista', prestadores)
      }
      return response
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  private motivoExclusaoItemRepasseDefault: any = {
    ids: [''],
    motivoExclusao: '',
    observacaoMotivoExclusao: '',
  }

  public motivoExclusaoItemRepasse: any = { ...this.motivoExclusaoItemRepasseDefault }
  public recalculoIds: string[] = []
  public recalculoIdsValorFixo: string[] = []

  @Mutation
  setMotivoExclusaoItemRepasseId(ids: any) {
    this.motivoExclusaoItemRepasse.ids = ids
  }

  @Mutation
  setRecalculoIds(ids: any) {
    this.recalculoIds = ids
  }

  @Mutation
  setRecalculoIdsValorFixo(ids: any) {
    this.recalculoIdsValorFixo = ids
  }

  @Mutation
  clearMotivoExclusaoItemRepasse() {
    this.motivoExclusaoItemRepasse = { ...this.motivoExclusaoItemRepasseDefault }
  }

  @Action
  async excluirItemRepasse() {
    try {
      const request = await this.remuneracaoMedica.excluirItemRepasse(this.motivoExclusaoItemRepasse)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async getStatusGeracaoRepasse() {
    try {
      const request = await this.remuneracaoMedica.getStatusGeracaoRepasse()
      this.context.commit('setStatusGeracaoRepasseFiltro', request.data)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }


  // SIGNALR REMUNERACAO MEDICA

  message: IRemuneracaoBackofficeMessage[] = []
  grupoHospitalId: string = ''
  gruposHospitaisIds: string[] = []


  @Mutation
  setGrupoHospital(value: any) {
    this.grupoHospitalId = value
  }

  @Mutation
  setGruposHospitaisIds(value: any) {
    this.gruposHospitaisIds = value
  }

  @Mutation
  addMessage(data: IRemuneracaoBackofficeMessage) {
    this.message.push(data)
  }

  @Action
  async getGrupoHospital() {
    try {
      const request = await this.remuneracaoMedica.getGrupoHospital()
      this.context.commit('setGrupoHospital', request.data.id)
      this.context.commit('setGruposHospitaisIds', request.data.hospitaisId)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async openConnection(grupoHospitalId: any) {
    await signalRRemuneracaoBackofficeService.openConnection(grupoHospitalId)
  }

  @Action
  async closeConnection() {
    await signalRRemuneracaoBackofficeService.closeConnection()
  }

  /** Seleção de itens de repassse para liberar ou integrar */
  itensDeRepasseSelecionados: any[] = []

  @Mutation
  setItensDeRepasseSelecionados(value: any) {
    this.itensDeRepasseSelecionados = value
  }

  @Mutation
  clearItensDeRepasseSelecionados() {
    this.itensDeRepasseSelecionados = []
  }

  @Action
  async integrarItensDeGeracaoDeRepasseNoHis() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse || this.aluguelPrestadorId,
        prestadorRecebimentoIds: filtrarItensPorAcao(this.itensDeRepasseSelecionados, 'PodeIntegrar').map((item: any) => item.id),
      }
      const request = await this.remuneracaoMedica.integrarItensDeGeracaoDeRepasseNoHis(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  @Action
  async liberarItensDeGeracaoDeRepasseNoHis() {
    try {
      const params: any = {
        geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse || this.aluguelPrestadorId,
        // prestadorRecebimentoIds: [
        //   '38f126f2-3535-4f79-99cc-98a6270e46f7',
        //   'cc9fc57d-b657-4b4f-9362-a28abed89493',
        //   '65afaaaa-5bd3-4b37-a9bd-7fb6a982e870',
        //   '35838cc4-f442-42ce-9226-848a9d560b9c',
        //   'a2c1c0f4-0144-4439-9962-4608cbe5f640',
        //   'fa2050c4-741a-412f-9db6-107ed1d58cdd',
        //   '13e4f4c4-0176-49a4-aa5c-2a35a156933f',
        //   'b3bd7bfe-036f-4ed5-bc31-3a115d69d0ba',
        //   '066b9b6f-b069-4ac3-a87f-045f9fa6f35a',
        //   '4eab4c4f-e134-4d67-af72-017438fe5006',
        // ],
        prestadorRecebimentoIds: filtrarItensPorAcao(this.itensDeRepasseSelecionados, 'PodeLiberar').map((item: any) => item.id),
      }
      const request = await this.remuneracaoMedica.liberarItensDeGeracaoDeRepasseNoHis(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição' }
    }
  }

  public relatoriosAreaEnum: Array<{ key: string, display: string }> = []

  @Mutation
  setRelatoriosAreaEnum(value: Array<{ key: string, display: string }>) {
    this.relatoriosAreaEnum = value
  }

  @Mutation
  setItemsMonitorIntegracao(value: any[]) {
    this.itemsMonitorIntegracao = value
  }

  @Mutation
  setTotalItemsMonitorIntegracao(value: number) {
    this.totalItemsMonitorIntegracao = value
  }

  @Mutation
  clearRelatoriosAreaEnum() {
    this.relatoriosAreaEnum = []
  }

  @Action
  async getRelatoriosAreaEnum() {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getRelatoriosAreaEnum()
      if (request.success) this.context.commit('setRelatoriosAreaEnum', request.data as Array<{ key: string, display: string }> || [])
      return request
    } catch (error) {
      this.context.commit('setRelatoriosAreaEnum', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getItemsMonitorIntegracao() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }

      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getItemsMonitorIntegracao(params)
      if (request.success) {
        this.context.commit('setItemsMonitorIntegracao', request.data.itens)
        this.context.commit('setTotalItemsMonitorIntegracao', request.data.totalRegistros)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os itens de monitoramento.' }
    }
  }

  @Action
  async getResumoEquipeMedica() {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getResumoEquipeMedica()
      if (request.success) {
        this.context.commit('setResumoEquipeMedica', request.data.equipesMedicas)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar as equipes médicas.' }
    }
  }

  @Action
  async getLocalExecucaoByFontePagadora() {
    try {
      const params: any = {
        fontePagadoraId: this.fontePagadoraFilter,
      }
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getLocalExecucaoByFontePagadora(params)
      if (request.success) {
        this.context.commit('setHospitaisOptions', request.data.itens || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os locais de execução.' }
    }
  }

  @Action
  async getEquipeMedicaList() {
    try {
      const params: any = {
        nome: this.nomeEquipeFilter,
      }

      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getEquipeMedicaList(params)
      if (request.success) {
        this.context.commit('setEquipesOptions', request.data.equipesMedicas || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar a equipe médica.' }
    }
  }

  @Action
  async desmembrarRepassesNegativos() {
    const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.desmembrarRepassesNegativos({ geracaoRepasseId: this.idForLoadValidacaoEGeracaoRepasse })
    return { success: request.success, message: request.message }
  }

  @Action
  async getPeriodos() {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getPeriodos()

      if (request.success) {
        this.context.commit('setPeriodos', request.data)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar períodos.' }
    }
  }

  @Action
  async alterarDatas(params: any) {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.alterarDatas(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao alterar as datas.' }
    }
  }

  @Action
  async getParametrosAplicacaoTaxaAluguel(params: any = {}) {
    try {
      const requestParams = {
        pagina: this.parametrosAplicacaoTaxaAluguelPagina,
        qtdPorPagina: this.parametrosAplicacaoTaxaAluguelQtdPorPagina,
        fontePagadoraId: this.parametrosAplicacaoTaxaAluguelFontePagadoraId || undefined,
        prestadorId: this.parametrosAplicacaoTaxaAluguelPrestadorId || undefined,
        ...params,
      }

      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getParametrosAplicacaoTaxaAluguelPrestador(requestParams)

      if (request.success) {
        this.context.commit('setConfigsParametrosAplicacao', request.data.itens || [])
        this.context.commit('setParametrosAplicacaoTaxaAluguelPagina', request.data.paginaAtual || this.parametrosAplicacaoTaxaAluguelPagina)
        this.context.commit('setParametrosAplicacaoTaxaAluguelTotal', request.data.totalRegistros || 0)
      }

      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os parâmetros de aplicação.' }
    }
  }

  @Action
  async getIntegracaoGeralRepasses() {
    try {
      const params: any = {
        pagina: this.pagina,
        qtdPorPagina: this.qtdPorPagina,
      }

      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getIntegracaoGeralRepasses(params)
      if (request.success) {
        this.context.commit('setIntegracaoGeralRepasses', request.data.itens)
        this.context.commit('setTotalIntegracaoGeralRepasses', request.data.totalRegistros)
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar a integração geral dos repasses.' }
    }
  }

  @Action
  async criarParametroAplicacaoTaxaAluguel() {
    try {
      const params = {
        fontePagadoraId: this.itemParametroAplicacaoTaxaAluguel.fontePagadoraId,
        prestadorId: this.itemParametroAplicacaoTaxaAluguel.prestadorId,
        centroDeCustoId: this.itemParametroAplicacaoTaxaAluguel.centroDeCustoId
      }

      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.createParametroAplicacaoTaxaAluguelPrestador(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao criar o parâmetro de aplicação.' }
    }
  }

  @Action
  async atualizarParametroAplicacaoTaxaAluguel() {
    try {
      const params = {
        id: this.itemParametroAplicacaoTaxaAluguel.id,
        fontePagadoraId: this.itemParametroAplicacaoTaxaAluguel.fontePagadoraId,
        prestadorId: this.itemParametroAplicacaoTaxaAluguel.prestadorId,
        centroDeCustoId: this.itemParametroAplicacaoTaxaAluguel.centroDeCustoId,
      }

      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.updateParametroAplicacaoTaxaAluguelPrestador(params, this.itemParametroAplicacaoTaxaAluguel.id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o parâmetro de aplicação.' }
    }
  }

  @Action
  async deletarParametroAplicacaoTaxaAluguel(id: string) {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.deleteParametroAplicacaoTaxaAluguelPrestador(id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o parâmetro de aplicação.' }
    }
  }

  @Action
  async getTaxaAluguelPrestadorConfig() {
    return this.context.dispatch('getParametrosAplicacaoTaxaAluguel')
  }

  @Action
  async criarConfigTaxaAluguelPrestador() {
    return this.context.dispatch('criarParametroAplicacaoTaxaAluguel')
  }

  /**
   * Especialidade
   */
  private itemsEspecialidadeDefault: any[] = []
  public itemsEspecialidade: any[] = [...this.itemsEspecialidadeDefault]
  private itemEspecialidadeDefault: any = { id: null, codigoUnico: '', descricao: '', hospitalId: null }
  public itemEspecialidade: any = { ...this.itemEspecialidadeDefault }
  public originalItemEspecialidade: any = { ...this.itemEspecialidadeDefault }
  public itemsEspecialidadePagina: number = 1
  public itemsEspecialidadeTotal: number = 0
  public filtroDescricaoEspecialidade: string = ''
  public filtroCodigoUnicoEspecialidade: string = ''
  public filtroHospitalIdEspecialidade: string = ''

  @Mutation
  setItemsEspecialidade(value: any[]) { this.itemsEspecialidade = value }

  @Mutation
  clearItemsEspecialidade() { this.itemsEspecialidade = [] }

  @Mutation
  setItemEspecialidade(value: any) { this.itemEspecialidade = value }

  @Mutation
  clearItemEspecialidade() { this.itemEspecialidade = { ...this.itemEspecialidadeDefault } }

  @Mutation
  setOriginalItemEspecialidade(value: any) { this.originalItemEspecialidade = value }

  @Mutation
  clearOriginalItemEspecialidade() { this.originalItemEspecialidade = { ...this.itemEspecialidadeDefault } }

  @Mutation
  setItemsEspecialidadePagina(value: number) { this.itemsEspecialidadePagina = value }

  @Mutation
  setItemsEspecialidadeTotal(value: number) { this.itemsEspecialidadeTotal = value }

  @Mutation
  removeItemEspecialidade(id: any) {
    const index = this.itemsEspecialidade.findIndex((e: any) => e.id === id)
    if (index !== -1) this.itemsEspecialidade.splice(index, 1)
  }

  @Mutation
  setFiltroDescricaoEspecialidade(value: string) { this.filtroDescricaoEspecialidade = value }

  @Mutation
  setFiltroCodigoUnicoEspecialidade(value: string) { this.filtroCodigoUnicoEspecialidade = value }

  @Mutation
  setFiltroHospitalIdEspecialidade(value: string) { this.filtroHospitalIdEspecialidade = value }

  @Action
  async getAllEspecialidade() {
    try {
      const params: any = {
        descricao: this.filtroDescricaoEspecialidade,
        codigoUnico: this.filtroCodigoUnicoEspecialidade,
        pagina: this.itemsEspecialidadePagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      if (this.filtroHospitalIdEspecialidade) params.hospitalId = this.filtroHospitalIdEspecialidade
      const request = await this.remuneracaoMedica.getEspecialidadeAll(params)
      if (request.success) {
        this.context.commit('setItemsEspecialidade', request.data.itens || [])
        this.context.commit('setItemsEspecialidadePagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsEspecialidadeTotal', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setItemsEspecialidade', [])
      return { success: false, message: 'Ocorreu um erro ao buscar especialidades.' }
    }
  }

  @Action
  async createEspecialidade() {
    try {
      const { codigoUnico, descricao, hospitalId } = this.itemEspecialidade
      const params: any = { codigoUnico, descricao }
      if (hospitalId) params.hospitalId = hospitalId
      const request = await this.remuneracaoMedica.createEspecialidade(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar a especialidade.' }
    }
  }

  @Action
  async updateEspecialidade() {
    try {
      if (isEqual(this.itemEspecialidade, this.originalItemEspecialidade)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }
      const { id, codigoUnico, descricao, hospitalId } = this.itemEspecialidade
      const request = await this.remuneracaoMedica.updateEspecialidade({ id, codigoUnico, descricao, hospitalId: hospitalId || null })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar a especialidade.' }
    }
  }

  @Action
  async deleteEspecialidade(id: any) {
    try {
      const request = await this.remuneracaoMedica.deleteEspecialidade(id)
      if (request.success) this.context.commit('removeItemEspecialidade', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar a especialidade.' }
    }
  }

  /**
   * SubEspecialidade
   */
  private itemsSubEspecialidadeDefault: any[] = []
  public itemsSubEspecialidade: any[] = [...this.itemsSubEspecialidadeDefault]
  private itemSubEspecialidadeDefault: any = { id: null, especialidadeId: null, descricao: '' }
  public itemSubEspecialidade: any = { ...this.itemSubEspecialidadeDefault }
  public originalItemSubEspecialidade: any = { ...this.itemSubEspecialidadeDefault }
  public itemsSubEspecialidadePagina: number = 1
  public itemsSubEspecialidadeTotal: number = 0
  public filtroEspecialidadeIdSubEsp: any = null
  public filtroDescricaoSubEspecialidade: string = ''

  @Mutation
  setItemsSubEspecialidade(value: any[]) { this.itemsSubEspecialidade = value }

  @Mutation
  clearItemsSubEspecialidade() { this.itemsSubEspecialidade = [] }

  @Mutation
  setItemSubEspecialidade(value: any) { this.itemSubEspecialidade = value }

  @Mutation
  clearItemSubEspecialidade() { this.itemSubEspecialidade = { ...this.itemSubEspecialidadeDefault } }

  @Mutation
  setOriginalItemSubEspecialidade(value: any) { this.originalItemSubEspecialidade = value }

  @Mutation
  clearOriginalItemSubEspecialidade() { this.originalItemSubEspecialidade = { ...this.itemSubEspecialidadeDefault } }

  @Mutation
  setItemsSubEspecialidadePagina(value: number) { this.itemsSubEspecialidadePagina = value }

  @Mutation
  setItemsSubEspecialidadeTotal(value: number) { this.itemsSubEspecialidadeTotal = value }

  @Mutation
  removeItemSubEspecialidade(id: any) {
    const index = this.itemsSubEspecialidade.findIndex((e: any) => e.id === id)
    if (index !== -1) this.itemsSubEspecialidade.splice(index, 1)
  }

  @Mutation
  setFiltroEspecialidadeIdSubEsp(value: any) { this.filtroEspecialidadeIdSubEsp = value }

  @Mutation
  setFiltroDescricaoSubEspecialidade(value: string) { this.filtroDescricaoSubEspecialidade = value }

  @Action
  async getAllSubEspecialidade() {
    try {
      const params: any = {
        pagina: this.itemsSubEspecialidadePagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      if (this.filtroEspecialidadeIdSubEsp) params.especialidadeId = this.filtroEspecialidadeIdSubEsp
      if (this.filtroDescricaoSubEspecialidade) params.descricao = this.filtroDescricaoSubEspecialidade
      const request = await this.remuneracaoMedica.getSubEspecialidadeAll(params)
      if (request.success) {
        this.context.commit('setItemsSubEspecialidade', request.data.itens || [])
        this.context.commit('setItemsSubEspecialidadePagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsSubEspecialidadeTotal', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setItemsSubEspecialidade', [])
      return { success: false, message: 'Ocorreu um erro ao buscar subespecialidades.' }
    }
  }

  @Action
  async createSubEspecialidade() {
    try {
      const { especialidadeId, descricao } = this.itemSubEspecialidade
      const request = await this.remuneracaoMedica.createSubEspecialidade({ especialidadeId, descricao })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar a subespecialidade.' }
    }
  }

  @Action
  async updateSubEspecialidade() {
    try {
      if (isEqual(this.itemSubEspecialidade, this.originalItemSubEspecialidade)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }
      const { id, especialidadeId, descricao } = this.itemSubEspecialidade
      const request = await this.remuneracaoMedica.updateSubEspecialidade({ id, especialidadeId, descricao })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar a subespecialidade.' }
    }
  }

  @Action
  async deleteSubEspecialidade(id: any) {
    try {
      const request = await this.remuneracaoMedica.deleteSubEspecialidade(id)
      if (request.success) this.context.commit('removeItemSubEspecialidade', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar a subespecialidade.' }
    }
  }

  /**
   * EspecialidadeProcedimento
   */
  private itemsEspecialidadeProcedimentoDefault: any[] = []
  public itemsEspecialidadeProcedimento: any[] = [...this.itemsEspecialidadeProcedimentoDefault]
  private itemEspecialidadeProcedimentoDefault: any = { id: null, especialidadeId: null, subEspecialidadeId: null, codigoProcedimento: '' }
  public itemEspecialidadeProcedimento: any = { ...this.itemEspecialidadeProcedimentoDefault }
  public originalItemEspecialidadeProcedimento: any = { ...this.itemEspecialidadeProcedimentoDefault }
  public itemsEspecialidadeProcedimentoPagina: number = 1
  public itemsEspecialidadeProcedimentoTotal: number = 0
  public filtroEspecialidadeIdProc: any = null
  public filtroSubEspecialidadeIdProc: any = null
  public filtroCodigoProcedimento: string = ''

  @Mutation
  setItemsEspecialidadeProcedimento(value: any[]) { this.itemsEspecialidadeProcedimento = value }

  @Mutation
  clearItemsEspecialidadeProcedimento() { this.itemsEspecialidadeProcedimento = [] }

  @Mutation
  setItemEspecialidadeProcedimento(value: any) { this.itemEspecialidadeProcedimento = value }

  @Mutation
  clearItemEspecialidadeProcedimento() { this.itemEspecialidadeProcedimento = { ...this.itemEspecialidadeProcedimentoDefault } }

  @Mutation
  setOriginalItemEspecialidadeProcedimento(value: any) { this.originalItemEspecialidadeProcedimento = value }

  @Mutation
  clearOriginalItemEspecialidadeProcedimento() { this.originalItemEspecialidadeProcedimento = { ...this.itemEspecialidadeProcedimentoDefault } }

  @Mutation
  setItemsEspecialidadeProcedimentoPagina(value: number) { this.itemsEspecialidadeProcedimentoPagina = value }

  @Mutation
  setItemsEspecialidadeProcedimentoTotal(value: number) { this.itemsEspecialidadeProcedimentoTotal = value }

  @Mutation
  removeItemEspecialidadeProcedimento(id: any) {
    const index = this.itemsEspecialidadeProcedimento.findIndex((e: any) => e.id === id)
    if (index !== -1) this.itemsEspecialidadeProcedimento.splice(index, 1)
  }

  @Mutation
  setFiltroEspecialidadeIdProc(value: any) { this.filtroEspecialidadeIdProc = value }

  @Mutation
  setFiltroSubEspecialidadeIdProc(value: any) { this.filtroSubEspecialidadeIdProc = value }

  @Mutation
  setFiltroCodigoProcedimento(value: string) { this.filtroCodigoProcedimento = value }

  @Action
  async getAllEspecialidadeProcedimento() {
    try {
      const params: any = {
        pagina: this.itemsEspecialidadeProcedimentoPagina,
        qtdPorPagina: this.qtdPorPagina,
      }
      if (this.filtroEspecialidadeIdProc) params.especialidadeId = this.filtroEspecialidadeIdProc
      if (this.filtroSubEspecialidadeIdProc) params.subEspecialidadeId = this.filtroSubEspecialidadeIdProc
      if (this.filtroCodigoProcedimento) params.codigoProcedimento = this.filtroCodigoProcedimento
      const request = await this.remuneracaoMedica.getEspecialidadeProcedimentoAll(params)
      if (request.success) {
        this.context.commit('setItemsEspecialidadeProcedimento', request.data.itens || [])
        this.context.commit('setItemsEspecialidadeProcedimentoPagina', request.data.paginaAtual || 1)
        this.context.commit('setItemsEspecialidadeProcedimentoTotal', request.data.totalRegistros || 0)
      }
      return request
    } catch (error) {
      this.context.commit('setItemsEspecialidadeProcedimento', [])
      return { success: false, message: 'Ocorreu um erro ao buscar especialidade procedimentos.' }
    }
  }

  @Action
  async createEspecialidadeProcedimento() {
    try {
      const { especialidadeId, subEspecialidadeId, codigoProcedimento } = this.itemEspecialidadeProcedimento
      const params: any = { especialidadeId, codigoProcedimento }
      if (subEspecialidadeId) params.subEspecialidadeId = subEspecialidadeId
      const request = await this.remuneracaoMedica.createEspecialidadeProcedimento(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar o vínculo especialidade-procedimento.' }
    }
  }

  @Action
  async updateEspecialidadeProcedimento() {
    try {
      if (isEqual(this.itemEspecialidadeProcedimento, this.originalItemEspecialidadeProcedimento)) return { success: true, message: MensagensDaApiEnum.UNCHANGED_PAYLOAD }
      const { id, especialidadeId, subEspecialidadeId, codigoProcedimento } = this.itemEspecialidadeProcedimento
      const params: any = { id, especialidadeId, codigoProcedimento }
      if (subEspecialidadeId) params.subEspecialidadeId = subEspecialidadeId
      const request = await this.remuneracaoMedica.updateEspecialidadeProcedimento(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao atualizar o vínculo especialidade-procedimento.' }
    }
  }

  @Action
  async deleteEspecialidadeProcedimento(id: any) {
    try {
      const request = await this.remuneracaoMedica.deleteEspecialidadeProcedimento(id)
      if (request.success) this.context.commit('removeItemEspecialidadeProcedimento', id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao apagar o vínculo especialidade-procedimento.' }
    }
  }

  @Action
  async createEspecialidadeProcedimentoDireto(params: { especialidadeId: any, subEspecialidadeId: any, codigoProcedimento: string }) {
    try {
      const payload: any = { especialidadeId: params.especialidadeId, codigoProcedimento: params.codigoProcedimento }
      if (params.subEspecialidadeId) payload.subEspecialidadeId = params.subEspecialidadeId
      const request = await this.remuneracaoMedica.createEspecialidadeProcedimento(payload)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao salvar.' }
    }
  }

  @Action
  async getSubEspecialidadeByEspId(especialidadeId: number): Promise<any[]> {
    try {
      const request = await this.remuneracaoMedica.getSubEspecialidadeAll({ especialidadeId, qtdPorPagina: 1000, pagina: 1 })
      return request.success ? ((request.data && request.data.itens) || []) : []
    } catch (error) { return [] }
  }

  @Action
  async getProcedimentosByEspId(especialidadeId: number): Promise<any[]> {
    try {
      const request = await this.remuneracaoMedica.getEspecialidadeProcedimentoAll({ especialidadeId, qtdPorPagina: 1000, pagina: 1 })
      return request.success ? ((request.data && request.data.itens) || []) : []
    } catch (error) { return [] }
  }

  @Action
  async criarIntegracaoRepasse(params: any) {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.criarIntegracaoRepasse(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao criar a integração de repasse.' }
    }
  }

  @Action
  async getRelatorioAll() {
    try {
      const request = await RemuneracaoMedicaApi.RemuneracaoMedicaApi.getRelatoriosByFontePagadora({paginar: false, area: 'GeracaoRepasse'})
      if (request.success) {
        this.context.commit('setRelatoriosAreaEnum', request.data.itens || [])
      }
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro ao buscar os relatórios.' }
    }
  }
}
